/* tslint:disable */
/* eslint-disable */
/**
 * C24 Community API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AppWidgetsResponse
 */
export interface AppWidgetsResponse {
    /**
     * 
     * @type {AppWidgetsResponseRelevantGroups}
     * @memberof AppWidgetsResponse
     */
    'relevantGroups'?: AppWidgetsResponseRelevantGroups;
    /**
     * 
     * @type {MapPreviewWidget}
     * @memberof AppWidgetsResponse
     */
    'mapPreview'?: MapPreviewWidget;
}
/**
 * Api items for app home relevant groups widget
 * @export
 * @interface AppWidgetsResponseRelevantGroups
 */
export interface AppWidgetsResponseRelevantGroups {
    /**
     * 
     * @type {string}
     * @memberof AppWidgetsResponseRelevantGroups
     */
    'title'?: string;
    /**
     * 
     * @type {Array<RelevantGroup>}
     * @memberof AppWidgetsResponseRelevantGroups
     */
    'groups'?: Array<RelevantGroup>;
}
/**
 * At location group participant statistics object
 * @export
 * @interface AtLocationGroupParticipantStatistics
 */
export interface AtLocationGroupParticipantStatistics {
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'bookingTravelerType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'bookingTravelerGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AtLocationGroupParticipantStatistics
     */
    'bookingTravelerAgeRange'?: string | null;
}
/**
 * chat base image
 * @export
 * @interface BaseImage
 */
export interface BaseImage {
    /**
     * 
     * @type {number}
     * @memberof BaseImage
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BaseImage
     */
    'url'?: string | null;
}
/**
 * base chat message
 * @export
 * @interface BaseMessage
 */
export interface BaseMessage {
    /**
     * 
     * @type {string}
     * @memberof BaseMessage
     */
    'key': string;
    /**
     * 
     * @type {ChatConversationParticipant}
     * @memberof BaseMessage
     */
    'createdBy': ChatConversationParticipant | null;
    /**
     * 
     * @type {string}
     * @memberof BaseMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof BaseMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof BaseMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof BaseMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof BaseMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseMessage
     */
    'isEdited': boolean;
}
/**
 * 
 * @export
 * @interface BookingInfo
 */
export interface BookingInfo {
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'to'?: string;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'travelerType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'travelerGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingInfo
     */
    'travelerAgeRange'?: string | null;
}
/**
 * Chat contact object
 * @export
 * @interface ChatContact
 */
export interface ChatContact {
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'lastActionAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatContact
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'association'?: string;
    /**
     * 
     * @type {UserStatistics}
     * @memberof ChatContact
     */
    'statistics'?: UserStatistics;
    /**
     * 
     * @type {boolean}
     * @memberof ChatContact
     */
    'isOnline'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatContact
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatContact
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface ChatConversationCreate
 */
export interface ChatConversationCreate {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatConversationCreate
     */
    'userUuids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreate
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreate
     */
    'name'?: string | null;
    /**
     * 
     * @type {ChatConversationCreateImage}
     * @memberof ChatConversationCreate
     */
    'image'?: ChatConversationCreateImage | null;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreate
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatConversationCreate
     */
    'groupIdInitiatedFrom'?: number | null;
}
/**
 * 
 * @export
 * @interface ChatConversationCreateImage
 */
export interface ChatConversationCreateImage {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationCreateImage
     */
    'key'?: string;
}
/**
 * 
 * @export
 * @interface ChatConversationLeave
 */
export interface ChatConversationLeave {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationLeave
     */
    'newOwnerUuid'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatConversationParticipant
 */
export interface ChatConversationParticipant {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'screenName': string;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'avatar': string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'role': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatConversationParticipant
     */
    'isCurrentUser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatConversationParticipant
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'activeState': string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatConversationParticipant
     */
    'gender': string | null;
}
/**
 * 
 * @export
 * @interface ChatConversationUpdate
 */
export interface ChatConversationUpdate {
    /**
     * 
     * @type {string}
     * @memberof ChatConversationUpdate
     */
    'name'?: string | null;
    /**
     * 
     * @type {ChatConversationCreateImage}
     * @memberof ChatConversationUpdate
     */
    'image'?: ChatConversationCreateImage | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChatConversationUpdate
     */
    'userUuids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ChatInit
 */
export interface ChatInit {
    /**
     * 
     * @type {string}
     * @memberof ChatInit
     */
    'groupId'?: string;
}
/**
 * chat last message
 * @export
 * @interface ChatLastMessage
 */
export interface ChatLastMessage {
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'key'?: string;
    /**
     * 
     * @type {ChatParticipant}
     * @memberof ChatLastMessage
     */
    'ownedBy'?: ChatParticipant | null;
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatLastMessage
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatLastMessage
     */
    'sentAt'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatLastMessage
     */
    'updatedAt'?: number | null;
    /**
     * 
     * @type {MessageImages}
     * @memberof ChatLastMessage
     */
    'images'?: MessageImages;
    /**
     * 
     * @type {boolean}
     * @memberof ChatLastMessage
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatLastMessage
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatLastMessage
     */
    'isEdited'?: boolean;
}
/**
 * chat message
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'key': string;
    /**
     * 
     * @type {ChatConversationParticipant}
     * @memberof ChatMessage
     */
    'createdBy': ChatConversationParticipant;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof ChatMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isEdited': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'type': ChatMessageTypeEnum;
    /**
     * 
     * @type {ReferencedMessage}
     * @memberof ChatMessage
     */
    'referencedMessage': ReferencedMessage | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessage
     */
    'isSeen': boolean;
    /**
     * 
     * @type {Array<ChatConversationParticipant>}
     * @memberof ChatMessage
     */
    'seenBy': Array<ChatConversationParticipant>;
    /**
     * 
     * @type {ChatMessageAllOfReactionCount}
     * @memberof ChatMessage
     */
    'reactionCount': ChatMessageAllOfReactionCount | null;
}

export const ChatMessageTypeEnum = {
    SystemConversationArchived: 'system-conversation-archived',
    SystemConversationCreated: 'system-conversation-created',
    SystemConversationReopened: 'system-conversation-reopened',
    SystemConversationRejoined: 'system-conversation-rejoined',
    SystemConversationTitle: 'system-conversation-title',
    SystemOwnerChanged: 'system-owner-changed',
    SystemParticipantLeft: 'system-participant-left',
    SystemParticipantsAdded: 'system-participants-added',
    SystemParticipantsRemoved: 'system-participants-removed',
    Message: 'message'
} as const;

export type ChatMessageTypeEnum = typeof ChatMessageTypeEnum[keyof typeof ChatMessageTypeEnum];

/**
 * 
 * @export
 * @interface ChatMessageAllOfReactionCount
 */
export interface ChatMessageAllOfReactionCount {
    [key: string]: number | any;

    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'dislike'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'like'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'love'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'laugh'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageAllOfReactionCount
     */
    'hushed'?: number;
}
/**
 * 
 * @export
 * @interface ChatMessageBase
 */
export interface ChatMessageBase {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'messageContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageBase
     */
    'referencedMessage'?: string | null;
    /**
     * 
     * @type {Array<TruckTourCommentsCreateRequestImageListInner>}
     * @memberof ChatMessageBase
     */
    'images'?: Array<TruckTourCommentsCreateRequestImageListInner> | null;
}
/**
 * 
 * @export
 * @interface ChatMessageCreate
 */
export interface ChatMessageCreate {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'messageContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageCreate
     */
    'referencedMessage'?: string | null;
    /**
     * 
     * @type {Array<TruckTourCommentsCreateRequestImageListInner>}
     * @memberof ChatMessageCreate
     */
    'images'?: Array<TruckTourCommentsCreateRequestImageListInner> | null;
}
/**
 * list of chat messages
 * @export
 * @interface ChatMessageList
 */
export interface ChatMessageList {
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof ChatMessageList
     */
    'messages'?: Array<ChatMessage>;
}
/**
 * 
 * @export
 * @interface ChatMessageMarkAsSeen
 */
export interface ChatMessageMarkAsSeen {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageMarkAsSeen
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageMarkAsSeen
     */
    'messageId'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageUpdate
 */
export interface ChatMessageUpdate {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'messageContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageUpdate
     */
    'referencedMessage'?: string | null;
    /**
     * 
     * @type {Array<TruckTourCommentsCreateRequestImageListInner>}
     * @memberof ChatMessageUpdate
     */
    'images'?: Array<TruckTourCommentsCreateRequestImageListInner> | null;
}
/**
 * 
 * @export
 * @interface ChatParticipant
 */
export interface ChatParticipant {
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'role'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatParticipant
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatParticipant
     */
    'gender'?: string | null;
}
/**
 * chat conversation with messages
 * @export
 * @interface ChatWithMessages
 */
export interface ChatWithMessages {
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'key'?: string;
    /**
     * 
     * @type {ChatParticipant}
     * @memberof ChatWithMessages
     */
    'ownedBy'?: ChatParticipant | null;
    /**
     * 
     * @type {BaseImage}
     * @memberof ChatWithMessages
     */
    'image'?: BaseImage | null;
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatWithMessages
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatWithMessages
     */
    'participantsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatWithMessages
     */
    'lastSeenTimestamp'?: number | null;
    /**
     * 
     * @type {ChatLastMessage}
     * @memberof ChatWithMessages
     */
    'lastMessage'?: ChatLastMessage | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatWithMessages
     */
    'isNotificationEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ChecktokCommentWithCursor
 */
export interface ChecktokCommentWithCursor {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'postId'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ChecktokCommentWithCursor
     */
    'reactionCount'?: { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isEditorial'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokCommentWithCursor
     */
    'timestamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isEdited'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithCursor
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {ChecktokReferencedComment}
     * @memberof ChecktokCommentWithCursor
     */
    'referencedComment'?: ChecktokReferencedComment;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {ChecktokUser}
     * @memberof ChecktokCommentWithCursor
     */
    'createdBy'?: ChecktokUser;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ChecktokImage>}
     * @memberof ChecktokCommentWithCursor
     */
    'images'?: Array<ChecktokImage>;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithCursor
     */
    'cursor'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokCommentWithSuspendedDeleted
 */
export interface ChecktokCommentWithSuspendedDeleted {
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'postId'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'reactionCount'?: { [key: string]: number; };
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isEditorial'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'timestamp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isEdited'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {ChecktokReferencedComment}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'referencedComment'?: ChecktokReferencedComment;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {ChecktokUser}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'createdBy'?: ChecktokUser;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ChecktokImage>}
     * @memberof ChecktokCommentWithSuspendedDeleted
     */
    'images'?: Array<ChecktokImage>;
}
/**
 * 
 * @export
 * @interface ChecktokImage
 */
export interface ChecktokImage {
    /**
     * 
     * @type {number}
     * @memberof ChecktokImage
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChecktokImage
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokImage
     */
    'authorAttribution'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokReferencedComment
 */
export interface ChecktokReferencedComment {
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {ChecktokUser}
     * @memberof ChecktokReferencedComment
     */
    'createdBy'?: ChecktokUser;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokReferencedComment
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<ChecktokImage>}
     * @memberof ChecktokReferencedComment
     */
    'images'?: Array<ChecktokImage>;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokReferencedComment
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokReferencedComment
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ChecktokReferencedComment
     */
    'image'?: any;
}
/**
 * 
 * @export
 * @interface ChecktokStory
 */
export interface ChecktokStory {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoURL'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoPreviewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'videoHls'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'ctaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStory
     */
    'ctaUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStory
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStory
     */
    'highlightedOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStory
     */
    'isSharingEnabled'?: boolean;
    /**
     * 
     * @type {ChecktokStoryThumbnails}
     * @memberof ChecktokStory
     */
    'thumbnails'?: ChecktokStoryThumbnails;
    /**
     * 
     * @type {ChecktokStoryComments}
     * @memberof ChecktokStory
     */
    'comments'?: ChecktokStoryComments;
    /**
     * 
     * @type {ChecktokStoryMetadata}
     * @memberof ChecktokStory
     */
    'metadata'?: ChecktokStoryMetadata;
}
/**
 * 
 * @export
 * @interface ChecktokStoryAuthenticatedUserMetadata
 */
export interface ChecktokStoryAuthenticatedUserMetadata {
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'reactionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'commentCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'shareCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'userCommented'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryAuthenticatedUserMetadata
     */
    'userReaction'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokStoryComments
 */
export interface ChecktokStoryComments {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryComments
     */
    'url'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokStoryFilter
 */
export interface ChecktokStoryFilter {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryFilter
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryFilter
     */
    'storyCount'?: number;
}
/**
 * 
 * @export
 * @interface ChecktokStoryForArchive
 */
export interface ChecktokStoryForArchive {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoURL'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoPreviewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'videoHls'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'ctaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'ctaUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForArchive
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryForArchive
     */
    'highlightedOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForArchive
     */
    'isSharingEnabled'?: boolean;
    /**
     * 
     * @type {ChecktokStoryThumbnails}
     * @memberof ChecktokStoryForArchive
     */
    'thumbnails'?: ChecktokStoryThumbnails;
    /**
     * 
     * @type {ChecktokStoryComments}
     * @memberof ChecktokStoryForArchive
     */
    'comments'?: ChecktokStoryComments;
    /**
     * 
     * @type {ChecktokStoryMetadata}
     * @memberof ChecktokStoryForArchive
     */
    'metadata'?: ChecktokStoryMetadata;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForArchive
     */
    'watchUrl'?: string;
}
/**
 * 
 * @export
 * @interface ChecktokStoryForAuthenticatedUser
 */
export interface ChecktokStoryForAuthenticatedUser {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoURL'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoPreviewUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'videoHls'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'product'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'ctaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'ctaUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'highlightedOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'isSharingEnabled'?: boolean;
    /**
     * 
     * @type {ChecktokStoryThumbnails}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'thumbnails'?: ChecktokStoryThumbnails;
    /**
     * 
     * @type {ChecktokStoryComments}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'comments'?: ChecktokStoryComments;
    /**
     * 
     * @type {ChecktokStoryAuthenticatedUserMetadata}
     * @memberof ChecktokStoryForAuthenticatedUser
     */
    'metadata'?: ChecktokStoryAuthenticatedUserMetadata;
}
/**
 * 
 * @export
 * @interface ChecktokStoryMetadata
 */
export interface ChecktokStoryMetadata {
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryMetadata
     */
    'reactionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryMetadata
     */
    'commentCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChecktokStoryMetadata
     */
    'shareCount'?: number;
}
/**
 * 
 * @export
 * @interface ChecktokStoryThumbnails
 */
export interface ChecktokStoryThumbnails {
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryThumbnails
     */
    'original'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokStoryThumbnails
     */
    'firstFrame'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokTrackingEvent
 */
export interface ChecktokTrackingEvent {
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'appType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'guidDevice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'eventName'?: ChecktokTrackingEventEventNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'eventTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'eventSession'?: string;
    /**
     * 
     * @type {ChecktokTrackingValue}
     * @memberof ChecktokTrackingEvent
     */
    'eventValue'?: ChecktokTrackingValue;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingEvent
     */
    'appSession'?: string | null;
}

export const ChecktokTrackingEventEventNameEnum = {
    VideoStart: 'videoStart',
    VideoPause: 'videoPause',
    VideoResume: 'videoResume',
    VideoFinish: 'videoFinish',
    VideoExit: 'videoExit',
    VideoReplay: 'videoReplay',
    VideoCtaClick: 'videoCtaClick'
} as const;

export type ChecktokTrackingEventEventNameEnum = typeof ChecktokTrackingEventEventNameEnum[keyof typeof ChecktokTrackingEventEventNameEnum];

/**
 * 
 * @export
 * @interface ChecktokTrackingValue
 */
export interface ChecktokTrackingValue {
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingValue
     */
    'origin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChecktokTrackingValue
     */
    'storyId'?: string | null;
}
/**
 * 
 * @export
 * @interface ChecktokUser
 */
export interface ChecktokUser {
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'avatar'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'gender'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChecktokUser
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChecktokUser
     */
    'activeState'?: string;
}
/**
 * 
 * @export
 * @interface CommentDeletedInfo
 */
export interface CommentDeletedInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentDeletedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDeletedInfo
     */
    'deletedAt'?: string;
}
/**
 * 
 * @export
 * @interface CommentLocationInfo
 */
export interface CommentLocationInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentLocationInfo
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentLocationInfo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentLocationInfo
     */
    'geoLat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommentLocationInfo
     */
    'geoLong'?: number | null;
}
/**
 * 
 * @export
 * @interface CommentReferencedInfo
 */
export interface CommentReferencedInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'askAnswerId'?: string | null;
    /**
     * 
     * @type {UserInfo}
     * @memberof CommentReferencedInfo
     */
    'user'?: UserInfo;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'content'?: string;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof CommentReferencedInfo
     */
    'images'?: Array<ImageInfo>;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentReferencedInfo
     */
    'communityLink'?: string;
}
/**
 * 
 * @export
 * @interface CommentUpdatedInfo
 */
export interface CommentUpdatedInfo {
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'postId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'askAnswerId'?: string | null;
    /**
     * 
     * @type {UserInfo}
     * @memberof CommentUpdatedInfo
     */
    'user'?: UserInfo;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'content'?: string;
    /**
     * 
     * @type {CommentLocationInfo}
     * @memberof CommentUpdatedInfo
     */
    'location'?: CommentLocationInfo | null;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof CommentUpdatedInfo
     */
    'images'?: Array<ImageInfo>;
    /**
     * 
     * @type {Array<CommentUpdatedInfoReactionCountInner>}
     * @memberof CommentUpdatedInfo
     */
    'reactionCount'?: Array<CommentUpdatedInfoReactionCountInner>;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfo
     */
    'communityLink'?: string;
    /**
     * 
     * @type {CommentReferencedInfo}
     * @memberof CommentUpdatedInfo
     */
    'referencedComment'?: CommentReferencedInfo | null;
}
/**
 * 
 * @export
 * @interface CommentUpdatedInfoReactionCountInner
 */
export interface CommentUpdatedInfoReactionCountInner {
    /**
     * 
     * @type {string}
     * @memberof CommentUpdatedInfoReactionCountInner
     */
    'reactionName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentUpdatedInfoReactionCountInner
     */
    'reactionCount'?: number;
}
/**
 * 
 * @export
 * @interface CommunityPointOfInterestGroupCategoryItem
 */
export interface CommunityPointOfInterestGroupCategoryItem {
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'icon'?: string;
    /**
     * 
     * @type {Array<CommunityPointOfInterestModel>}
     * @memberof CommunityPointOfInterestGroupCategoryItem
     */
    'pointOfInterestModels'?: Array<CommunityPointOfInterestModel>;
}
/**
 * 
 * @export
 * @interface CommunityPointOfInterestModel
 */
export interface CommunityPointOfInterestModel {
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestModel
     */
    'name'?: string;
    /**
     * 
     * @type {CommunityPointOfInterestTypeModel}
     * @memberof CommunityPointOfInterestModel
     */
    'pointOfInterestTypeModel'?: CommunityPointOfInterestTypeModel;
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestModel
     */
    'distanceInKilometers'?: number | null;
}
/**
 * 
 * @export
 * @interface CommunityPointOfInterestTypeModel
 */
export interface CommunityPointOfInterestTypeModel {
    /**
     * 
     * @type {number}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPointOfInterestTypeModel
     */
    'displayName'?: string;
}
/**
 * image external api
 * @export
 * @interface ConversationImageExternal
 */
export interface ConversationImageExternal {
    /**
     * 
     * @type {string}
     * @memberof ConversationImageExternal
     */
    'small'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationImageExternal
     */
    'big'?: string | null;
}
/**
 * link for external api
 * @export
 * @interface ConversationLinkExternal
 */
export interface ConversationLinkExternal {
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'desktop'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'tablet'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'app'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationLinkExternal
     */
    'tabletapp'?: string;
}
/**
 * chat conversations list
 * @export
 * @interface ConversationList
 */
export interface ConversationList {
    /**
     * 
     * @type {Array<ConversationWithMessages>}
     * @memberof ConversationList
     */
    'result': Array<ConversationWithMessages>;
    /**
     * 
     * @type {ConversationListMeta}
     * @memberof ConversationList
     */
    'meta': ConversationListMeta;
}
/**
 * 
 * @export
 * @interface ConversationListMeta
 */
export interface ConversationListMeta {
    /**
     * 
     * @type {string}
     * @memberof ConversationListMeta
     */
    'next'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationListMeta
     */
    'prev'?: string;
}
/**
 * metadata for external api
 * @export
 * @interface ConversationMetadataExternal
 */
export interface ConversationMetadataExternal {
    /**
     * 
     * @type {number}
     * @memberof ConversationMetadataExternal
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationMetadataExternal
     */
    'totalCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationMetadataExternal
     */
    'firstUnreadAnchor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationMetadataExternal
     */
    'latestMessageId'?: string | null;
}
/**
 * conversation related group
 * @export
 * @interface ConversationRelatedGroup
 */
export interface ConversationRelatedGroup {
    /**
     * 
     * @type {number}
     * @memberof ConversationRelatedGroup
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ConversationRelatedGroup
     */
    'name': string;
}
/**
 * chat conversation with last two messages
 * @export
 * @interface ConversationWithLastMessages
 */
export interface ConversationWithLastMessages {
    /**
     * 
     * @type {string}
     * @memberof ConversationWithLastMessages
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithLastMessages
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithLastMessages
     */
    'messagesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithLastMessages
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof ConversationWithLastMessages
     */
    'lastMessages'?: Array<ChatMessage>;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithLastMessages
     */
    'displayDate'?: string;
}
/**
 * chat conversation with messages
 * @export
 * @interface ConversationWithMessages
 */
export interface ConversationWithMessages {
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'key': string;
    /**
     * 
     * @type {ChatConversationParticipant}
     * @memberof ConversationWithMessages
     */
    'ownedBy': ChatConversationParticipant | null;
    /**
     * 
     * @type {Array<ChatConversationParticipant>}
     * @memberof ConversationWithMessages
     */
    'participants': Array<ChatConversationParticipant>;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessages
     */
    'participantsCount': number;
    /**
     * 
     * @type {ConversationWithMessagesImage}
     * @memberof ConversationWithMessages
     */
    'image': ConversationWithMessagesImage;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'type': ConversationWithMessagesTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'subtype': ConversationWithMessagesSubtypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'updatedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ConversationWithMessages
     */
    'isOwner': boolean;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessages
     */
    'messagesCount': number;
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessages
     */
    'unreadCount': number;
    /**
     * 
     * @type {ChatMessage}
     * @memberof ConversationWithMessages
     */
    'lastMessage': ChatMessage | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConversationWithMessages
     */
    'isNotificationEnabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessages
     */
    'displayDate': string;
    /**
     * 
     * @type {ConversationRelatedGroup}
     * @memberof ConversationWithMessages
     */
    'relatedGroup': ConversationRelatedGroup | null;
}

export const ConversationWithMessagesTypeEnum = {
    Direct: 'direct',
    Group: 'group',
    Public: 'public'
} as const;

export type ConversationWithMessagesTypeEnum = typeof ConversationWithMessagesTypeEnum[keyof typeof ConversationWithMessagesTypeEnum];
export const ConversationWithMessagesSubtypeEnum = {
    Country: 'country',
    City: 'city',
    Hotel: 'hotel',
    Region: 'region'
} as const;

export type ConversationWithMessagesSubtypeEnum = typeof ConversationWithMessagesSubtypeEnum[keyof typeof ConversationWithMessagesSubtypeEnum];

/**
 * chat conversation with messages
 * @export
 * @interface ConversationWithMessagesExternal
 */
export interface ConversationWithMessagesExternal {
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'preview'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'partner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'type'?: string;
    /**
     * 
     * @type {ConversationLinkExternal}
     * @memberof ConversationWithMessagesExternal
     */
    'link'?: ConversationLinkExternal;
    /**
     * 
     * @type {ConversationImageExternal}
     * @memberof ConversationWithMessagesExternal
     */
    'image'?: ConversationImageExternal | null;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'product'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {ConversationMetadataExternal}
     * @memberof ConversationWithMessagesExternal
     */
    'metaData'?: ConversationMetadataExternal;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConversationWithMessagesExternal
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesExternal
     */
    'activity'?: string | null;
}
/**
 * 
 * @export
 * @interface ConversationWithMessagesImage
 */
export interface ConversationWithMessagesImage {
    /**
     * 
     * @type {number}
     * @memberof ConversationWithMessagesImage
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConversationWithMessagesImage
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ConversationsListRequest
 */
export interface ConversationsListRequest {
    /**
     * get chats of specific type
     * @type {Array<string>}
     * @memberof ConversationsListRequest
     */
    'types'?: Array<ConversationsListRequestTypesEnum>;
    /**
     * default: 20, max: 50
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'limit'?: number | null;
    /**
     * id of the conversation, will be included
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'after'?: number | null;
    /**
     * id of the conversation, will be included
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'before'?: number | null;
    /**
     * get updates after specified timestamp
     * @type {number}
     * @memberof ConversationsListRequest
     */
    'diff'?: number | null;
    /**
     * get chats with unread messages
     * @type {boolean}
     * @memberof ConversationsListRequest
     */
    'unreadOnly'?: boolean | null;
}

export const ConversationsListRequestTypesEnum = {
    Direct: 'direct',
    Group: 'group',
    Public: 'public'
} as const;

export type ConversationsListRequestTypesEnum = typeof ConversationsListRequestTypesEnum[keyof typeof ConversationsListRequestTypesEnum];

/**
 * 
 * @export
 * @interface CoreAuthorAttributedImageItem
 */
export interface CoreAuthorAttributedImageItem {
    /**
     * 
     * @type {number}
     * @memberof CoreAuthorAttributedImageItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreAuthorAttributedImageItem
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreAuthorAttributedImageItem
     */
    'authorAttribution'?: string | null;
}
/**
 * 
 * @export
 * @interface CoreFile
 */
export interface CoreFile {
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'bucket'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreFile
     */
    'thumbnail'?: string;
}
/**
 * 
 * @export
 * @interface CoreGlobalConfigItem
 */
export interface CoreGlobalConfigItem {
    /**
     * 
     * @type {string}
     * @memberof CoreGlobalConfigItem
     */
    'name': string;
    /**
     * 
     * @type {CoreGlobalConfigItemValue}
     * @memberof CoreGlobalConfigItem
     */
    'value': CoreGlobalConfigItemValue;
}
/**
 * @type CoreGlobalConfigItemValue
 * @export
 */
export type CoreGlobalConfigItemValue = boolean | number | string;

/**
 * 
 * @export
 * @interface CoreMediaItem
 */
export interface CoreMediaItem {
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreMediaItem
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'postId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'commentId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoreMediaItem
     */
    'cursor'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreMediaItem
     */
    'imageUrl'?: string;
}
/**
 * shortened url
 * @export
 * @interface CoreShortUrl
 */
export interface CoreShortUrl {
    /**
     * 
     * @type {number}
     * @memberof CoreShortUrl
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CoreShortUrl
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreShortUrl
     */
    'long'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreShortUrl
     */
    'short'?: string;
}
/**
 * Cursor to start the list from
 * @export
 * @interface CursorParam
 */
export interface CursorParam {
    /**
     * 
     * @type {string}
     * @memberof CursorParam
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CursorParam
     */
    'direction'?: string | null;
}
/**
 * Experience information
 * @export
 * @interface Experience
 */
export interface Experience {
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'imageUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'ratingAverage': number;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'ratingCount': number;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'distanceInKilometers': number | null;
    /**
     * 
     * @type {number}
     * @memberof Experience
     */
    'price': number;
    /**
     * 
     * @type {boolean}
     * @memberof Experience
     */
    'freeCancellation': boolean;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'travelersInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Experience
     */
    'link': string;
}
/**
 * 
 * @export
 * @interface ExperiencesList
 */
export interface ExperiencesList {
    /**
     * 
     * @type {Array<Experience>}
     * @memberof ExperiencesList
     */
    'result': Array<Experience>;
    /**
     * 
     * @type {string}
     * @memberof ExperiencesList
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof ExperiencesList
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof ExperiencesList
     */
    'searchLink': string;
}
/**
 * 
 * @export
 * @interface ExternalConversationsListRequest
 */
export interface ExternalConversationsListRequest {
    /**
     * 
     * @type {number}
     * @memberof ExternalConversationsListRequest
     */
    'userId'?: number;
    /**
     * default: 20, max: 200
     * @type {number}
     * @memberof ExternalConversationsListRequest
     */
    'limit'?: number | null;
    /**
     * default: 20, max: 50
     * @type {Array<string>}
     * @memberof ExternalConversationsListRequest
     */
    'orderBy'?: Array<ExternalConversationsListRequestOrderByEnum> | null;
    /**
     * 
     * @type {ExternalConversationsListRequestTags}
     * @memberof ExternalConversationsListRequest
     */
    'tags'?: ExternalConversationsListRequestTags | null;
    /**
     * id of the conversation, will be included
     * @type {string}
     * @memberof ExternalConversationsListRequest
     */
    'after'?: string | null;
    /**
     * id of the conversation, will be included
     * @type {string}
     * @memberof ExternalConversationsListRequest
     */
    'before'?: string | null;
}

export const ExternalConversationsListRequestOrderByEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type ExternalConversationsListRequestOrderByEnum = typeof ExternalConversationsListRequestOrderByEnum[keyof typeof ExternalConversationsListRequestOrderByEnum];

/**
 * tags of a conversation
 * @export
 * @interface ExternalConversationsListRequestTags
 */
export interface ExternalConversationsListRequestTags {
    /**
     * 
     * @type {string}
     * @memberof ExternalConversationsListRequestTags
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalConversationsListRequestTags
     */
    'value'?: string;
}
/**
 * External group object
 * @export
 * @interface ExternalGroup
 */
export interface ExternalGroup {
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'object_key'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'group_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'subline'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'travel_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'travel_count_text'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalGroup
     */
    'post_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'image_author_attribution'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExternalGroup
     */
    'avatars'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'cta_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalGroup
     */
    'cta_url'?: string;
}
/**
 * 
 * @export
 * @interface ExternalGroupDetailsRequest
 */
export interface ExternalGroupDetailsRequest {
    /**
     * Community group ID
     * @type {number}
     * @memberof ExternalGroupDetailsRequest
     */
    'groupId'?: number;
}
/**
 * External group details result
 * @export
 * @interface ExternalGroupDetailsResult
 */
export interface ExternalGroupDetailsResult {
    /**
     * Group subline (typically member count)
     * @type {string}
     * @memberof ExternalGroupDetailsResult
     */
    'subline'?: string;
    /**
     * List of member avatar URLs
     * @type {Array<string>}
     * @memberof ExternalGroupDetailsResult
     */
    'avatars'?: Array<string>;
}
/**
 * External group object
 * @export
 * @interface ExternalHotelRelatedGroups
 */
export interface ExternalHotelRelatedGroups {
    /**
     * 
     * @type {number}
     * @memberof ExternalHotelRelatedGroups
     */
    'hotel_id'?: number;
    /**
     * 
     * @type {Array<ExternalGroup>}
     * @memberof ExternalHotelRelatedGroups
     */
    'groups'?: Array<ExternalGroup>;
}
/**
 * List of users following another user
 * @export
 * @interface FollowersList
 */
export interface FollowersList {
    /**
     * 
     * @type {number}
     * @memberof FollowersList
     */
    'totalCount': number;
    /**
     * 
     * @type {Array<UserProfile>}
     * @memberof FollowersList
     */
    'data': Array<UserProfile>;
    /**
     * 
     * @type {string}
     * @memberof FollowersList
     */
    'cursor': string | null;
}
/**
 * Generated answer object
 * @export
 * @interface GeneratedAnswer
 */
export interface GeneratedAnswer {
    /**
     * 
     * @type {string}
     * @memberof GeneratedAnswer
     */
    'suggestionText'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneratedAnswer
     */
    'topics'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneratedAnswer
     */
    'suggestedAnswers'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GeneratedAnswer
     */
    'chips'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GeneratedAnswer
     */
    'updatedAt'?: string;
}
/**
 * Alternative group for post creation
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'subline': string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'atLocationCount': string | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'imageAuthorAttribution'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'geoLat': number | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'geoLong': number | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'parentId': number | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'parentName': string | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'cityId': number | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'cityName': string | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'regionId': number | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'regionName': string | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'countryId': number | null;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'countryName': string | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof Group
     */
    'mapCenter': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof Group
     */
    'mapSw': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof Group
     */
    'mapNe': MapCoordinate | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'mapZoom': number | null;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'starRating': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    'starRatingOfficial': boolean | null;
}
/**
 * Group details
 * @export
 * @interface GroupDetailsType
 */
export interface GroupDetailsType {
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'type': GroupDetailsTypeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'geoLat': number | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'geoLong': number | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupDetailsType
     */
    'mapCenter': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupDetailsType
     */
    'mapNe': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupDetailsType
     */
    'mapSw': MapCoordinate | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'mapZoom': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'atLocationCount': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'isActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'parentId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'parentName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'starRating': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'starRatingOfficial': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'subline': string;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'imageAuthorAttribution': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'activeBooking': boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'activeBookingStart': string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'activeBookingEnd': string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupDetailsType
     */
    'activeBookingLabel': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'atLocation': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'isMember': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'hasImages': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'hasRatings': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'isJoined': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDetailsType
     */
    'isNotificationEnabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'viewCount': number;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'postsCount': number;
    /**
     * 
     * @type {number}
     * @memberof GroupDetailsType
     */
    'parentPostsCount': number;
    /**
     * 
     * @type {Array<GroupLink>}
     * @memberof GroupDetailsType
     */
    'links': Array<GroupLink>;
}

export const GroupDetailsTypeTypeEnum = {
    Celebrity: 'celebrity',
    Public: 'public',
    Hotel: 'HOTEL',
    Holidayhome: 'HOLIDAYHOME',
    City: 'CITY',
    Region: 'REGION',
    Country: 'COUNTRY',
    Poi: 'POI',
    TruckTourPublic: 'TRUCK_TOUR_PUBLIC',
    TruckTourPrivate: 'TRUCK_TOUR_PRIVATE',
    TruckTourTruck: 'TRUCK_TOUR_TRUCK'
} as const;

export type GroupDetailsTypeTypeEnum = typeof GroupDetailsTypeTypeEnum[keyof typeof GroupDetailsTypeTypeEnum];

/**
 * 
 * @export
 * @interface GroupInfo
 */
export interface GroupInfo {
    /**
     * 
     * @type {number}
     * @memberof GroupInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInfo
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInfo
     */
    'travelLocationId'?: string | null;
    /**
     * 
     * @type {Array<PointOfInterestInfo>}
     * @memberof GroupInfo
     */
    'pois'?: Array<PointOfInterestInfo>;
}
/**
 * Group details link type
 * @export
 * @interface GroupLink
 */
export interface GroupLink {
    /**
     * 
     * @type {string}
     * @memberof GroupLink
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof GroupLink
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GroupLink
     */
    'url': string;
}
/**
 * Group Participant filter
 * @export
 * @interface GroupParticipantFilter
 */
export interface GroupParticipantFilter {
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantFilter
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantFilter
     */
    'type': GroupParticipantFilterTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantFilter
     */
    'name': GroupParticipantFilterNameEnum;
    /**
     * 
     * @type {object}
     * @memberof GroupParticipantFilter
     */
    'criteria': object;
    /**
     * 
     * @type {boolean}
     * @memberof GroupParticipantFilter
     */
    'default': boolean;
}

export const GroupParticipantFilterTypeEnum = {
    All: 'ALL',
    AtLocation: 'AT_LOCATION',
    ActiveCategory: 'ACTIVE_CATEGORY'
} as const;

export type GroupParticipantFilterTypeEnum = typeof GroupParticipantFilterTypeEnum[keyof typeof GroupParticipantFilterTypeEnum];
export const GroupParticipantFilterNameEnum = {
    AtLocation: 'AT_LOCATION',
    CustomRange: 'CUSTOM_RANGE',
    HasUpcomingBooking: 'HAS_UPCOMING_BOOKING',
    AllowContact: 'ALLOW_CONTACT',
    Online: 'ONLINE',
    Engaged: 'ENGAGED',
    Insider: 'INSIDER',
    New: 'NEW'
} as const;

export type GroupParticipantFilterNameEnum = typeof GroupParticipantFilterNameEnum[keyof typeof GroupParticipantFilterNameEnum];

/**
 * At location group participant statistics object
 * @export
 * @interface GroupParticipantStatistics
 */
export interface GroupParticipantStatistics {
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantStatistics
     */
    'bookingTravelerType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantStatistics
     */
    'bookingTravelerGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupParticipantStatistics
     */
    'bookingTravelerAgeRange'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'likesReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'groupsJoinedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'engagementScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupParticipantStatistics
     */
    'experienceScore'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupParticipantStatistics
     */
    'atLocation'?: boolean;
}
/**
 * Group search item object
 * @export
 * @interface GroupSearchItem
 */
export interface GroupSearchItem {
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItem
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'coverImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'country'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItem
     */
    'popularityTier'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSearchItem
     */
    'subline'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItem
     */
    'category'?: number | null;
    /**
     * 
     * @type {Array<GroupSearchItemGeoPointInner>}
     * @memberof GroupSearchItem
     */
    'geoPoint'?: Array<GroupSearchItemGeoPointInner> | null;
}
/**
 * 
 * @export
 * @interface GroupSearchItemGeoPointInner
 */
export interface GroupSearchItemGeoPointInner {
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItemGeoPointInner
     */
    'lon'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupSearchItemGeoPointInner
     */
    'lat'?: number;
}
/**
 * This schema returned used for suggested group
 * @export
 * @interface GroupSuggestion
 */
export interface GroupSuggestion {
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'type': GroupSuggestionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'geoLat': number | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'geoLong': number | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupSuggestion
     */
    'mapCenter': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupSuggestion
     */
    'mapNe': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof GroupSuggestion
     */
    'mapSw': MapCoordinate | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'mapZoom': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'atLocationCount': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupSuggestion
     */
    'isActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'parentId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'parentName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'starRating': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupSuggestion
     */
    'starRatingOfficial': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'subline': string;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'imageAuthorAttribution': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'countryId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'countryName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'cityId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'cityName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'regionId': number | null;
    /**
     * 
     * @type {string}
     * @memberof GroupSuggestion
     */
    'regionName': string | null;
    /**
     * 
     * @type {number}
     * @memberof GroupSuggestion
     */
    'distanceInKilometers': number;
    /**
     * 
     * @type {Array<PublicProfile>}
     * @memberof GroupSuggestion
     */
    'topParticipants': Array<PublicProfile>;
}

export const GroupSuggestionTypeEnum = {
    Celebrity: 'celebrity',
    Public: 'public',
    Hotel: 'HOTEL',
    Holidayhome: 'HOLIDAYHOME',
    City: 'CITY',
    Region: 'REGION',
    Country: 'COUNTRY',
    Poi: 'POI',
    TruckTourPublic: 'TRUCK_TOUR_PUBLIC',
    TruckTourPrivate: 'TRUCK_TOUR_PRIVATE',
    TruckTourTruck: 'TRUCK_TOUR_TRUCK'
} as const;

export type GroupSuggestionTypeEnum = typeof GroupSuggestionTypeEnum[keyof typeof GroupSuggestionTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const GroupTypeEnum = {
    Celebrity: 'celebrity',
    Public: 'public',
    Hotel: 'HOTEL',
    Holidayhome: 'HOLIDAYHOME',
    City: 'CITY',
    Region: 'REGION',
    Country: 'COUNTRY',
    Poi: 'POI',
    TruckTourPublic: 'TRUCK_TOUR_PUBLIC',
    TruckTourPrivate: 'TRUCK_TOUR_PRIVATE',
    TruckTourTruck: 'TRUCK_TOUR_TRUCK'
} as const;

export type GroupTypeEnum = typeof GroupTypeEnum[keyof typeof GroupTypeEnum];


/**
 * chat image
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'authorAttribution'?: string | null;
}
/**
 * 
 * @export
 * @interface ImageInfo
 */
export interface ImageInfo {
    /**
     * 
     * @type {number}
     * @memberof ImageInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageInfo
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ImageInfo
     */
    'width'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ImageInfo
     */
    'height'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ImageInfo
     */
    'authorAttribution'?: string | null;
}
/**
 * chat init data
 * @export
 * @interface InitData
 */
export interface InitData {
    /**
     * 
     * @type {string}
     * @memberof InitData
     */
    'chatId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitData
     */
    'alreadyVisited'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitData
     */
    'uuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof InitData
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof InitData
     */
    'chatType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitData
     */
    'isNotificationEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InitData
     */
    'hasAtleastOneMessage'?: boolean;
}
/**
 * 
 * @export
 * @interface LotteryStop
 */
export interface LotteryStop {
    /**
     * 
     * @type {number}
     * @memberof LotteryStop
     */
    'id'?: number;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof LotteryStop
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {number}
     * @memberof LotteryStop
     */
    'possible_prizes_per_user'?: number | null;
    /**
     * 
     * @type {Array<StopPrizeItem>}
     * @memberof LotteryStop
     */
    'prize_items'?: Array<StopPrizeItem>;
}
/**
 * map coordinates
 * @export
 * @interface MapCoordinate
 */
export interface MapCoordinate {
    /**
     * 
     * @type {number}
     * @memberof MapCoordinate
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof MapCoordinate
     */
    'long': number;
}
/**
 * 
 * @export
 * @interface MapPreviewConfig
 */
export interface MapPreviewConfig {
    /**
     * 
     * @type {MapPreviewConfigCenter}
     * @memberof MapPreviewConfig
     */
    'center'?: MapPreviewConfigCenter;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfig
     */
    'zoom'?: number;
    /**
     * 
     * @type {MapPreviewConfigBounds}
     * @memberof MapPreviewConfig
     */
    'bounds'?: MapPreviewConfigBounds;
}
/**
 * 
 * @export
 * @interface MapPreviewConfigBounds
 */
export interface MapPreviewConfigBounds {
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    'n'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    'w'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    's'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigBounds
     */
    'e'?: number;
}
/**
 * 
 * @export
 * @interface MapPreviewConfigCenter
 */
export interface MapPreviewConfigCenter {
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigCenter
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewConfigCenter
     */
    'geoLong'?: number;
}
/**
 * 
 * @export
 * @interface MapPreviewGroup
 */
export interface MapPreviewGroup {
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'geoLong'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof MapPreviewGroup
     */
    'visibility'?: number;
    /**
     * 
     * @type {string}
     * @memberof MapPreviewGroup
     */
    'iconUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface MapPreviewWidget
 */
export interface MapPreviewWidget {
    /**
     * 
     * @type {MapPreviewConfig}
     * @memberof MapPreviewWidget
     */
    'map'?: MapPreviewConfig;
    /**
     * 
     * @type {Array<MapPreviewGroup>}
     * @memberof MapPreviewWidget
     */
    'groups'?: Array<MapPreviewGroup>;
}
/**
 * chat image
 * @export
 * @interface MessageImages
 */
export interface MessageImages {
    /**
     * 
     * @type {Array<Image>}
     * @memberof MessageImages
     */
    'images'?: Array<Image>;
}
/**
 * conversation messages list
 * @export
 * @interface MessageList
 */
export interface MessageList {
    /**
     * 
     * @type {Array<UserChatMessage>}
     * @memberof MessageList
     */
    'result'?: Array<UserChatMessage>;
    /**
     * 
     * @type {number}
     * @memberof MessageList
     */
    'pollingInterval'?: number;
}
/**
 * News widget item
 * @export
 * @interface NewsWidgetItem
 */
export interface NewsWidgetItem {
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'type'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof NewsWidgetItem
     */
    'itemId'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'authorUuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'authorGender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'subline'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'hasImage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'hasLink'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'isSuspended'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsWidgetItem
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NewsWidgetItem
     */
    'messageCount'?: number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof NewsWidgetItem
     */
    'reactionCount'?: { [key: string]: number; };
    /**
     * 
     * @type {Array<string>}
     * @memberof NewsWidgetItem
     */
    'userReactions'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof NewsWidgetItem
     */
    'commentCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsWidgetItem
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationInputNewsFeedInput
 */
export interface NotificationInputNewsFeedInput {
    /**
     * List of newsId\'s (uuid)
     * @type {Array<string>}
     * @memberof NotificationInputNewsFeedInput
     */
    'newsIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface NotificationMultiUserImageInternalNotification
 */
export interface NotificationMultiUserImageInternalNotification {
    /**
     * 
     * @type {number}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'token'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'previewImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'classification'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'displayDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'users'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'seenAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'updatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMultiUserImageInternalNotification
     */
    'deletedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationNewsFeedMeta
 */
export interface NotificationNewsFeedMeta {
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'unread'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedMeta
     */
    'page'?: number;
}
/**
 * 
 * @export
 * @interface NotificationNewsFeedNewsFeedAdd
 */
export interface NotificationNewsFeedNewsFeedAdd {
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'news_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'subline'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'image_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'target_url'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'user_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'product'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationNewsFeedNewsFeedAdd
     */
    'is_read'?: boolean;
}
/**
 * User notification settings object
 * @export
 * @interface NotificationSettings
 */
export interface NotificationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPush'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationEmail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationComment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationLike'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPost'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPrivateMessage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationGroupMessage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    'notificationPublicMessage'?: boolean;
}
/**
 * 
 * @export
 * @interface PointOfInterestInfo
 */
export interface PointOfInterestInfo {
    /**
     * 
     * @type {number}
     * @memberof PointOfInterestInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PointOfInterestInfo
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PointOfInterestInfo
     */
    'type'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PointOfInterestInfo
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof PointOfInterestInfo
     */
    'geoLong'?: number;
}
/**
 * 
 * @export
 * @interface PollOptionInfo
 */
export interface PollOptionInfo {
    /**
     * 
     * @type {number}
     * @memberof PollOptionInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PollOptionInfo
     */
    'content'?: string;
    /**
     * 
     * @type {number}
     * @memberof PollOptionInfo
     */
    'responseCount'?: number;
}
/**
 * 
 * @export
 * @interface PostCreateRequest
 */
export interface PostCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'content': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostCreateRequest
     */
    'isQuestion': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'sourceType': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'location': string | null;
    /**
     * 
     * @type {number}
     * @memberof PostCreateRequest
     */
    'geoLat': number | null;
    /**
     * 
     * @type {number}
     * @memberof PostCreateRequest
     */
    'geoLong': number | null;
    /**
     * 
     * @type {Array<TruckTourCommentsCreateRequestImageListInner>}
     * @memberof PostCreateRequest
     */
    'imageList': Array<TruckTourCommentsCreateRequestImageListInner> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostCreateRequest
     */
    'repostToChats': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'pollType': string | null;
    /**
     * 
     * @type {Array<PostCreateRequestPollOptionsInner>}
     * @memberof PostCreateRequest
     */
    'pollOptions': Array<PostCreateRequestPollOptionsInner> | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'pollClosedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequest
     */
    'locationId': string | null;
}
/**
 * 
 * @export
 * @interface PostCreateRequestPollOptionsInner
 */
export interface PostCreateRequestPollOptionsInner {
    /**
     * 
     * @type {boolean}
     * @memberof PostCreateRequestPollOptionsInner
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostCreateRequestPollOptionsInner
     */
    'content'?: string;
}
/**
 * 
 * @export
 * @interface PostCreateResponse
 */
export interface PostCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof PostCreateResponse
     */
    'message': string;
    /**
     * ID of the created post
     * @type {number}
     * @memberof PostCreateResponse
     */
    'postId': number;
}
/**
 * 
 * @export
 * @interface PostDeletedInfo
 */
export interface PostDeletedInfo {
    /**
     * 
     * @type {string}
     * @memberof PostDeletedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostDeletedInfo
     */
    'deletedAt'?: string;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInner
 */
export interface PostListResponsePropertyInner {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'id'?: number;
    /**
     * 
     * @type {PostListResponsePropertyInnerGroup}
     * @memberof PostListResponsePropertyInner
     */
    'group'?: PostListResponsePropertyInnerGroup;
    /**
     * 
     * @type {PostListResponsePropertyInnerUser}
     * @memberof PostListResponsePropertyInner
     */
    'user'?: PostListResponsePropertyInnerUser;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'suspendedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'releasedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'releasedBy'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInner
     */
    'location'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'geoLat'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'geoLong'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInner
     */
    'commentCount'?: number;
    /**
     * 
     * @type {Array<PostListResponsePropertyInnerImagesInner>}
     * @memberof PostListResponsePropertyInner
     */
    'images'?: Array<PostListResponsePropertyInnerImagesInner>;
    /**
     * 
     * @type {Array<PostListResponsePropertyInnerVideosInner>}
     * @memberof PostListResponsePropertyInner
     */
    'videos'?: Array<PostListResponsePropertyInnerVideosInner>;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerGroup
 */
export interface PostListResponsePropertyInnerGroup {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroup
     * @deprecated
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'image': string;
    /**
     * 
     * @type {PostListResponsePropertyInnerGroupLocation}
     * @memberof PostListResponsePropertyInnerGroup
     */
    'location': PostListResponsePropertyInnerGroupLocation;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerGroupLocation
 */
export interface PostListResponsePropertyInnerGroupLocation {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'geoLat': number;
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerGroupLocation
     */
    'geoLong': number;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerImagesInner
 */
export interface PostListResponsePropertyInnerImagesInner {
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerImagesInner
     */
    'imageURI'?: string;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerUser
 */
export interface PostListResponsePropertyInnerUser {
    /**
     * 
     * @type {number}
     * @memberof PostListResponsePropertyInnerUser
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerUser
     */
    'screenName': string;
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerUser
     */
    'avatar'?: string;
}
/**
 * 
 * @export
 * @interface PostListResponsePropertyInnerVideosInner
 */
export interface PostListResponsePropertyInnerVideosInner {
    /**
     * 
     * @type {string}
     * @memberof PostListResponsePropertyInnerVideosInner
     */
    'videoUri'?: string;
}
/**
 * 
 * @export
 * @interface PostLocationInfo
 */
export interface PostLocationInfo {
    /**
     * 
     * @type {string}
     * @memberof PostLocationInfo
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostLocationInfo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostLocationInfo
     */
    'geoLat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PostLocationInfo
     */
    'geoLong'?: number | null;
}
/**
 * 
 * @export
 * @interface PostPollInfo
 */
export interface PostPollInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof PostPollInfo
     */
    'options'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostPollInfo
     */
    'closedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface PostSuggestedStop
 */
export interface PostSuggestedStop {
    /**
     * 
     * @type {number}
     * @memberof PostSuggestedStop
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PostSuggestedStop
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface PostUpdateRequest
 */
export interface PostUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PostUpdateRequest
     */
    'content': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostUpdateRequest
     */
    'isQuestion'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PostUpdateRequest
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostUpdateRequest
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PostUpdateRequest
     */
    'geoLat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PostUpdateRequest
     */
    'geoLong'?: number | null;
    /**
     * 
     * @type {Array<PostUpdateRequestImageListInner>}
     * @memberof PostUpdateRequest
     */
    'imageList'?: Array<PostUpdateRequestImageListInner> | null;
}
/**
 * 
 * @export
 * @interface PostUpdateRequestImageListInner
 */
export interface PostUpdateRequestImageListInner {
    /**
     * 
     * @type {number}
     * @memberof PostUpdateRequestImageListInner
     */
    'id'?: number;
    /**
     * Storage key of the image
     * @type {string}
     * @memberof PostUpdateRequestImageListInner
     */
    'key'?: string;
    /**
     * Delete flag
     * @type {boolean}
     * @memberof PostUpdateRequestImageListInner
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @interface PostUpdateResponse
 */
export interface PostUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof PostUpdateResponse
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof PostUpdateResponse
     */
    'postId': number;
}
/**
 * 
 * @export
 * @interface PostUpdatedInfo
 */
export interface PostUpdatedInfo {
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'askQuestionId'?: string | null;
    /**
     * 
     * @type {GroupInfo}
     * @memberof PostUpdatedInfo
     */
    'group'?: GroupInfo;
    /**
     * 
     * @type {UserInfo}
     * @memberof PostUpdatedInfo
     */
    'user'?: UserInfo;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostUpdatedInfo
     */
    'isQuestion'?: boolean;
    /**
     * 
     * @type {PostLocationInfo}
     * @memberof PostUpdatedInfo
     */
    'location'?: PostLocationInfo | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostUpdatedInfo
     */
    'predictedTags'?: Array<string>;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof PostUpdatedInfo
     */
    'images'?: Array<ImageInfo>;
    /**
     * 
     * @type {Array<ImageInfo>}
     * @memberof PostUpdatedInfo
     */
    'videos'?: Array<ImageInfo>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostUpdatedInfo
     */
    'reactionCount'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {PostPollInfo}
     * @memberof PostUpdatedInfo
     */
    'poll'?: PostPollInfo | null;
    /**
     * 
     * @type {string}
     * @memberof PostUpdatedInfo
     */
    'communityLink'?: string;
}
/**
 * User privacy settings object
 * @export
 * @interface PrivacySettings
 */
export interface PrivacySettings {
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showPostCollection'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showInPublicSearch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showInGroupSearch'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrivacySettings
     */
    'showProfilePicture'?: boolean;
}
/**
 * 
 * @export
 * @interface PrivateStop
 */
export interface PrivateStop {
    /**
     * 
     * @type {Array<TruckStopChip>}
     * @memberof PrivateStop
     */
    'chips'?: Array<TruckStopChip>;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrivateStop
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'displayDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof PrivateStop
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof PrivateStop
     */
    'application'?: TruckStopApplication;
    /**
     * 
     * @type {TruckBadge}
     * @memberof PrivateStop
     */
    'mapBadge'?: TruckBadge;
    /**
     * 
     * @type {TruckBadge}
     * @memberof PrivateStop
     */
    'sheetBadge'?: TruckBadge;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'information'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrivateStop
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PrivateStop
     */
    'lotteryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PrivateStop
     */
    'maxLotteryWinCount'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof PrivateStop
     */
    'lotteryState'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'communityFeedUrl'?: string | null;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof PrivateStop
     */
    'media'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof PrivateStop
     */
    'merch'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'type'?: PrivateStopTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PrivateStop
     */
    'state'?: PrivateStopStateEnum;
}

export const PrivateStopTypeEnum = {
    Public: 'public',
    Truck: 'truck',
    Private: 'private'
} as const;

export type PrivateStopTypeEnum = typeof PrivateStopTypeEnum[keyof typeof PrivateStopTypeEnum];
export const PrivateStopStateEnum = {
    Live: 'live',
    Unconfirmed: 'unconfirmed',
    Upcoming: 'upcoming',
    Countdown: 'countdown',
    Ended: 'ended',
    Cancelled: 'cancelled',
    Delayed: 'delayed'
} as const;

export type PrivateStopStateEnum = typeof PrivateStopStateEnum[keyof typeof PrivateStopStateEnum];

/**
 * Profile object
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'fallbackAvatar'?: string;
    /**
     * 
     * @type {PrivacySettings}
     * @memberof Profile
     */
    'privacySettings'?: PrivacySettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof Profile
     */
    'notificationSettings'?: NotificationSettings;
    /**
     * 
     * @type {SessionUserStatistics}
     * @memberof Profile
     */
    'statistics'?: SessionUserStatistics;
}
/**
 * 
 * @export
 * @interface PromotedGroup
 */
export interface PromotedGroup {
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'type': PromotedGroupTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'geoLat': number | null;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'geoLong': number | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof PromotedGroup
     */
    'mapCenter': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof PromotedGroup
     */
    'mapNe': MapCoordinate | null;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof PromotedGroup
     */
    'mapSw': MapCoordinate | null;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'mapZoom': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'atLocationCount': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'isActive': boolean;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'parentId': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'parentName': string | null;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'starRating': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'starRatingOfficial': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'subline': string;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'imageAuthorAttribution': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'activeBooking': boolean;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'activeBookingStart': string | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'activeBookingLabel': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'atLocation': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'isMember': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'hasImages': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'hasRatings': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'isJoined': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PromotedGroup
     */
    'isNotificationEnabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'viewCount': number;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'postsCount': number;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'parentPostsCount': number;
    /**
     * 
     * @type {Array<GroupLink>}
     * @memberof PromotedGroup
     */
    'links': Array<GroupLink>;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'countryId': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'countryName': string | null;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'cityId': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'cityName': string | null;
    /**
     * 
     * @type {number}
     * @memberof PromotedGroup
     */
    'regionId': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromotedGroup
     */
    'regionName': string | null;
    /**
     * 
     * @type {Array<PublicProfile>}
     * @memberof PromotedGroup
     */
    'topParticipants': Array<PublicProfile>;
}

export const PromotedGroupTypeEnum = {
    Celebrity: 'celebrity',
    Public: 'public',
    Hotel: 'HOTEL',
    Holidayhome: 'HOLIDAYHOME',
    City: 'CITY',
    Region: 'REGION',
    Country: 'COUNTRY',
    Poi: 'POI',
    TruckTourPublic: 'TRUCK_TOUR_PUBLIC',
    TruckTourPrivate: 'TRUCK_TOUR_PRIVATE',
    TruckTourTruck: 'TRUCK_TOUR_TRUCK'
} as const;

export type PromotedGroupTypeEnum = typeof PromotedGroupTypeEnum[keyof typeof PromotedGroupTypeEnum];

/**
 * User public privacy settings object
 * @export
 * @interface PublicPrivacySettings
 */
export interface PublicPrivacySettings {
    /**
     * 
     * @type {boolean}
     * @memberof PublicPrivacySettings
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicPrivacySettings
     */
    'showPostCollection'?: boolean;
}
/**
 * Public profile object
 * @export
 * @interface PublicProfile
 */
export interface PublicProfile {
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    'allowToContact'?: boolean;
    /**
     * 
     * @type {PublicPrivacySettings}
     * @memberof PublicProfile
     */
    'privacySettings'?: PublicPrivacySettings;
    /**
     * 
     * @type {UserStatistics}
     * @memberof PublicProfile
     */
    'statistics'?: UserStatistics;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicProfile
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicProfile
     */
    'isOnboarded'?: boolean;
}
/**
 * 
 * @export
 * @interface PublicStop
 */
export interface PublicStop {
    /**
     * 
     * @type {Array<TruckStopChip>}
     * @memberof PublicStop
     */
    'chips'?: Array<TruckStopChip>;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof PublicStop
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'displayDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof PublicStop
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof PublicStop
     */
    'application'?: TruckStopApplication;
    /**
     * 
     * @type {TruckBadge}
     * @memberof PublicStop
     */
    'mapBadge'?: TruckBadge;
    /**
     * 
     * @type {TruckBadge}
     * @memberof PublicStop
     */
    'sheetBadge'?: TruckBadge;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'information'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PublicStop
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicStop
     */
    'lotteryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PublicStop
     */
    'maxLotteryWinCount'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof PublicStop
     */
    'lotteryState'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'communityFeedUrl'?: string | null;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof PublicStop
     */
    'media'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof PublicStop
     */
    'merch'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'type'?: PublicStopTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PublicStop
     */
    'state'?: PublicStopStateEnum;
}

export const PublicStopTypeEnum = {
    Public: 'public',
    Truck: 'truck',
    Private: 'private'
} as const;

export type PublicStopTypeEnum = typeof PublicStopTypeEnum[keyof typeof PublicStopTypeEnum];
export const PublicStopStateEnum = {
    Live: 'live',
    Unconfirmed: 'unconfirmed',
    Upcoming: 'upcoming',
    Countdown: 'countdown',
    Ended: 'ended',
    Cancelled: 'cancelled',
    Delayed: 'delayed'
} as const;

export type PublicStopStateEnum = typeof PublicStopStateEnum[keyof typeof PublicStopStateEnum];

/**
 * 
 * @export
 * @interface ReactionUpdate
 */
export interface ReactionUpdate {
    /**
     * 
     * @type {string}
     * @memberof ReactionUpdate
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReactionUpdate
     */
    'reactionTypeName'?: string;
}
/**
 * referenced chat message
 * @export
 * @interface ReferencedMessage
 */
export interface ReferencedMessage {
    /**
     * 
     * @type {string}
     * @memberof ReferencedMessage
     */
    'key': string;
    /**
     * 
     * @type {ChatConversationParticipant}
     * @memberof ReferencedMessage
     */
    'createdBy': ChatConversationParticipant;
    /**
     * 
     * @type {string}
     * @memberof ReferencedMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof ReferencedMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof ReferencedMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof ReferencedMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferencedMessage
     */
    'isEdited': boolean;
}
/**
 * 
 * @export
 * @interface RelevantGroup
 */
export interface RelevantGroup {
    /**
     * 
     * @type {number}
     * @memberof RelevantGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'subline'?: string;
    /**
     * 
     * @type {number}
     * @memberof RelevantGroup
     */
    'travelCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelevantGroup
     */
    'postCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'image'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RelevantGroup
     */
    'avatars'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'ctaText'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'ctaUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelevantGroup
     */
    'imageAuthorAttribution'?: string | null;
}
/**
 * Current session user statistics object
 * @export
 * @interface SessionUserStatistics
 */
export interface SessionUserStatistics {
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'likesReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'groupsJoinedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'daysActive'?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUserStatistics
     */
    'totalScore'?: number;
}
/**
 * Simple user object
 * @export
 * @interface SimpleUser
 */
export interface SimpleUser {
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleUser
     */
    'avatar'?: string | null;
}
/**
 * 
 * @export
 * @interface StopPrizeItem
 */
export interface StopPrizeItem {
    /**
     * 
     * @type {string}
     * @memberof StopPrizeItem
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof StopPrizeItem
     */
    'description'?: string;
    /**
     * 
     * @type {TruckPresentationHttpOutputPrizePrizeTypeEnum}
     * @memberof StopPrizeItem
     */
    'type'?: TruckPresentationHttpOutputPrizePrizeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StopPrizeItem
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StopPrizeItem
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StopPrizeItem
     */
    'icon_image'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StopPrizeItem
     */
    'amount'?: number | null;
    /**
     * cs plan ID in case of type=voucher
     * @type {string}
     * @memberof StopPrizeItem
     */
    'cs_plan_id'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TippspielGameResultEnum = {
    Win: 'win',
    Loss: 'loss',
    Draw: 'draw'
} as const;

export type TippspielGameResultEnum = typeof TippspielGameResultEnum[keyof typeof TippspielGameResultEnum];


/**
 * 
 * @export
 * @interface TippspielTeamHistories
 */
export interface TippspielTeamHistories {
    /**
     * 
     * @type {Array<TippspielTeamHistory>}
     * @memberof TippspielTeamHistories
     */
    'teamHomeHistory'?: Array<TippspielTeamHistory>;
    /**
     * 
     * @type {Array<TippspielTeamHistory>}
     * @memberof TippspielTeamHistories
     */
    'teamAwayHistory'?: Array<TippspielTeamHistory>;
}
/**
 * 
 * @export
 * @interface TippspielTeamHistory
 */
export interface TippspielTeamHistory {
    /**
     * 
     * @type {TippspielGameResultEnum}
     * @memberof TippspielTeamHistory
     */
    'gameResult'?: TippspielGameResultEnum;
    /**
     * 
     * @type {string}
     * @memberof TippspielTeamHistory
     */
    'sportradarId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TippspielTeamHistory
     */
    'gameStartsAt'?: string;
}


/**
 * 
 * @export
 * @interface TippspielUserUuidOutput
 */
export interface TippspielUserUuidOutput {
    /**
     * 
     * @type {string}
     * @memberof TippspielUserUuidOutput
     */
    'userId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TippspielUserUuidOutput
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {TippspielUserUuidOutputInteractions}
     * @memberof TippspielUserUuidOutput
     */
    'interactions'?: TippspielUserUuidOutputInteractions;
    /**
     * 
     * @type {boolean}
     * @memberof TippspielUserUuidOutput
     */
    'isOnboarded'?: boolean;
}
/**
 * 
 * @export
 * @interface TippspielUserUuidOutputInteractions
 */
export interface TippspielUserUuidOutputInteractions {
    /**
     * 
     * @type {any}
     * @memberof TippspielUserUuidOutputInteractions
     */
    'polls'?: any;
    /**
     * 
     * @type {any}
     * @memberof TippspielUserUuidOutputInteractions
     */
    'reactions'?: any;
    /**
     * 
     * @type {any}
     * @memberof TippspielUserUuidOutputInteractions
     */
    'postsComments'?: any;
}
/**
 * Top participant user object
 * @export
 * @interface TopParticipantUser
 */
export interface TopParticipantUser {
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'avatar': string;
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TopParticipantUser
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface TruckBadge
 */
export interface TruckBadge {
    /**
     * 
     * @type {boolean}
     * @memberof TruckBadge
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TruckBadge
     */
    'color'?: string | null;
    /**
     * 
     * @type {TruckDomainBadgeStateEnum}
     * @memberof TruckBadge
     */
    'state'?: TruckBadgeStateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof TruckBadge
     */
    'textColor'?: string | null;
}

export const TruckBadgeStateEnum = {
    Date: 'date',
    Countdown: 'countdown',
    Live: 'live',
    Cancelled: 'cancelled',
    Delayed: 'delayed'
} as const;

export type TruckBadgeStateEnum = typeof TruckBadgeStateEnum[keyof typeof TruckBadgeStateEnum];

/**
 * 
 * @export
 * @interface TruckSearchStop
 */
export interface TruckSearchStop {
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'description': string;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckSearchStop
     */
    'location': TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof TruckSearchStop
     */
    'application': TruckStopApplication;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'startDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckSearchStop
     */
    'endDate': string | null;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof TruckSearchStop
     */
    'media': Array<TruckStopMediaItem>;
    /**
     * 
     * @type {number}
     * @memberof TruckSearchStop
     */
    'level': number | null;
}
/**
 * 
 * @export
 * @interface TruckStop
 */
export interface TruckStop {
    /**
     * 
     * @type {Array<TruckStopChip>}
     * @memberof TruckStop
     */
    'chips'?: Array<TruckStopChip>;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckStop
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'displayDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckStop
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof TruckStop
     */
    'application'?: TruckStopApplication;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TruckStop
     */
    'mapBadge'?: TruckBadge;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TruckStop
     */
    'sheetBadge'?: TruckBadge;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'information'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckStop
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TruckStop
     */
    'lotteryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TruckStop
     */
    'maxLotteryWinCount'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TruckStop
     */
    'lotteryState'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'communityFeedUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'state'?: string;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof TruckStop
     */
    'media'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckStop
     */
    'garageLocation'?: TruckStopLocation;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'type'?: TruckStopTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TruckStop
     */
    'stopId'?: string | null;
}

export const TruckStopTypeEnum = {
    Public: 'public',
    Truck: 'truck',
    Private: 'private'
} as const;

export type TruckStopTypeEnum = typeof TruckStopTypeEnum[keyof typeof TruckStopTypeEnum];

/**
 * 
 * @export
 * @interface TruckStopApplication
 */
export interface TruckStopApplication {
    /**
     * 
     * @type {boolean}
     * @memberof TruckStopApplication
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TruckStopApplication
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopApplication
     */
    'subtitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopApplication
     */
    'ctaText'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopApplication
     */
    'ctaUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopApplication
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface TruckStopBanner
 */
export interface TruckStopBanner {
    /**
     * 
     * @type {string}
     * @memberof TruckStopBanner
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopBanner
     */
    'linkoutUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopBanner
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopBanner
     */
    'ctaUrl'?: string;
}
/**
 * 
 * @export
 * @interface TruckStopChip
 */
export interface TruckStopChip {
    /**
     * 
     * @type {string}
     * @memberof TruckStopChip
     */
    'icon'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopChip
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopChip
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopChip
     */
    'style'?: TruckStopChipStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof TruckStopChip
     */
    'urlType'?: TruckStopChipUrlTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TruckStopChip
     */
    'buttonType'?: TruckStopChipButtonTypeEnum;
}

export const TruckStopChipStyleEnum = {
    Selected: 'selected',
    Default: 'default'
} as const;

export type TruckStopChipStyleEnum = typeof TruckStopChipStyleEnum[keyof typeof TruckStopChipStyleEnum];
export const TruckStopChipUrlTypeEnum = {
    Fullscreen: 'fullscreen',
    Deeplink: 'deeplink',
    Sheet: 'sheet',
    ApiPost: 'api-post'
} as const;

export type TruckStopChipUrlTypeEnum = typeof TruckStopChipUrlTypeEnum[keyof typeof TruckStopChipUrlTypeEnum];
export const TruckStopChipButtonTypeEnum = {
    Lottery: 'lottery',
    Notification: 'notification',
    Community: 'community'
} as const;

export type TruckStopChipButtonTypeEnum = typeof TruckStopChipButtonTypeEnum[keyof typeof TruckStopChipButtonTypeEnum];

/**
 * 
 * @export
 * @interface TruckStopComment
 */
export interface TruckStopComment {
    /**
     * 
     * @type {string}
     * @memberof TruckStopComment
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopComment
     */
    'content'?: string | null;
    /**
     * 
     * @type {TruckStopUser}
     * @memberof TruckStopComment
     */
    'user'?: TruckStopUser;
    /**
     * 
     * @type {string}
     * @memberof TruckStopComment
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopComment
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopComment
     */
    'localId'?: string | null;
}
/**
 * 
 * @export
 * @interface TruckStopConfig
 */
export interface TruckStopConfig {
    /**
     * 
     * @type {string}
     * @memberof TruckStopConfig
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopConfig
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface TruckStopLocation
 */
export interface TruckStopLocation {
    /**
     * 
     * @type {string}
     * @memberof TruckStopLocation
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckStopLocation
     */
    'radius'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckStopLocation
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckStopLocation
     */
    'longitude'?: number;
}
/**
 * 
 * @export
 * @interface TruckStopMediaItem
 */
export interface TruckStopMediaItem {
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'type'?: TruckStopMediaItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'state'?: TruckStopMediaItemStateEnum;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'thumbnail'?: string;
    /**
     * 
     * @type {TruckStopMetadata}
     * @memberof TruckStopMediaItem
     */
    'metadata'?: TruckStopMetadata;
    /**
     * 
     * @type {number}
     * @memberof TruckStopMediaItem
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'commentUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'label'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TruckStopMediaItem
     */
    'itemCount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMediaItem
     */
    'linkoutUrl'?: string | null;
}

export const TruckStopMediaItemTypeEnum = {
    Image: 'image',
    Video: 'video',
    Stream: 'stream',
    Countdown: 'countdown'
} as const;

export type TruckStopMediaItemTypeEnum = typeof TruckStopMediaItemTypeEnum[keyof typeof TruckStopMediaItemTypeEnum];
export const TruckStopMediaItemStateEnum = {
    None: 'none',
    Error: 'error',
    Interrupted: 'interrupted',
    Live: 'live'
} as const;

export type TruckStopMediaItemStateEnum = typeof TruckStopMediaItemStateEnum[keyof typeof TruckStopMediaItemStateEnum];

/**
 * 
 * @export
 * @interface TruckStopMetadata
 */
export interface TruckStopMetadata {
    /**
     * 
     * @type {number}
     * @memberof TruckStopMetadata
     */
    'viewCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckStopMetadata
     */
    'reactionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckStopMetadata
     */
    'commentCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckStopMetadata
     */
    'shareCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TruckStopMetadata
     */
    'userCommented'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TruckStopMetadata
     */
    'userReaction'?: string | null;
}
/**
 * 
 * @export
 * @interface TruckStopUser
 */
export interface TruckStopUser {
    /**
     * 
     * @type {string}
     * @memberof TruckStopUser
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopUser
     */
    'screenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopUser
     */
    'avatar'?: string;
}
/**
 * 
 * @export
 * @interface TruckStopWidget
 */
export interface TruckStopWidget {
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckStopWidget
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckStopWidget
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckStopWidget
     */
    'information'?: string | null;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TruckStopWidget
     */
    'badge'?: TruckBadge;
}
/**
 * 
 * @export
 * @interface TruckTourAuthValidateIndex200Response
 */
export interface TruckTourAuthValidateIndex200Response {
    /**
     * 
     * @type {string}
     * @memberof TruckTourAuthValidateIndex200Response
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourAuthValidateIndex200Response
     */
    'uuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof TruckTourAuthValidateIndex200Response
     */
    'isOnboarded': boolean;
}
/**
 * 
 * @export
 * @interface TruckTourAuthValidateIndex550Response
 */
export interface TruckTourAuthValidateIndex550Response {
    /**
     * 
     * @type {string}
     * @memberof TruckTourAuthValidateIndex550Response
     */
    'error': string;
}
/**
 * Comment item response
 * @export
 * @interface TruckTourComment
 */
export interface TruckTourComment {
    /**
     * 
     * @type {string}
     * @memberof TruckTourComment
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof TruckTourComment
     */
    'postId': number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourComment
     */
    'content': string | null;
    /**
     * 
     * @type {object}
     * @memberof TruckTourComment
     */
    'createdBy': object;
    /**
     * 
     * @type {Array<string>}
     * @memberof TruckTourComment
     */
    'images': Array<string>;
    /**
     * 
     * @type {Array<object>}
     * @memberof TruckTourComment
     */
    'reactionCount': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof TruckTourComment
     */
    'totalReactionCount': number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourComment
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourComment
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TruckTourComment
     */
    'isHighlighted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TruckTourComment
     */
    'isEditorial': boolean;
    /**
     * 
     * @type {string}
     * @memberof TruckTourComment
     */
    'updatedAt': string | null;
}
/**
 * 
 * @export
 * @interface TruckTourCommentsCreateRequest
 */
export interface TruckTourCommentsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsCreateRequest
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsCreateRequest
     */
    'linkoutUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsCreateRequest
     */
    'referencedComment'?: string;
    /**
     * 
     * @type {Array<TruckTourCommentsCreateRequestImageListInner>}
     * @memberof TruckTourCommentsCreateRequest
     */
    'imageList'?: Array<TruckTourCommentsCreateRequestImageListInner>;
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsCreateRequest
     */
    'sourceType'?: string;
}
/**
 * 
 * @export
 * @interface TruckTourCommentsCreateRequestImageListInner
 */
export interface TruckTourCommentsCreateRequestImageListInner {
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsCreateRequestImageListInner
     */
    'key'?: string;
}
/**
 * 
 * @export
 * @interface TruckTourCommentsReactionCreate201ResponseInner
 */
export interface TruckTourCommentsReactionCreate201ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsReactionCreate201ResponseInner
     */
    'message'?: string;
    /**
     * 
     * @type {TruckTourCommentsReactionCreate201ResponseInnerCommentReactions}
     * @memberof TruckTourCommentsReactionCreate201ResponseInner
     */
    'commentReactions'?: TruckTourCommentsReactionCreate201ResponseInnerCommentReactions;
}
/**
 * 
 * @export
 * @interface TruckTourCommentsReactionCreate201ResponseInnerCommentReactions
 */
export interface TruckTourCommentsReactionCreate201ResponseInnerCommentReactions {
    /**
     * 
     * @type {Array<TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsUserReactionsInner>}
     * @memberof TruckTourCommentsReactionCreate201ResponseInnerCommentReactions
     */
    'userReactions'?: Array<TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsUserReactionsInner>;
    /**
     * 
     * @type {TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsReactionCount}
     * @memberof TruckTourCommentsReactionCreate201ResponseInnerCommentReactions
     */
    'reactionCount'?: TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsReactionCount;
}
/**
 * 
 * @export
 * @interface TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsReactionCount
 */
export interface TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsReactionCount {
    /**
     * 
     * @type {number}
     * @memberof TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsReactionCount
     */
    'name'?: number;
}
/**
 * 
 * @export
 * @interface TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsUserReactionsInner
 */
export interface TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsUserReactionsInner {
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsUserReactionsInner
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface TruckTourCommentsReactionCreateRequest
 */
export interface TruckTourCommentsReactionCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsReactionCreateRequest
     */
    'reactionTypeName'?: string;
}
/**
 * 
 * @export
 * @interface TruckTourCommentsReportCreateRequest
 */
export interface TruckTourCommentsReportCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof TruckTourCommentsReportCreateRequest
     */
    'reportClassificationId': number;
}
/**
 * 
 * @export
 * @interface TruckTourCommentsUpdateRequest
 */
export interface TruckTourCommentsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsUpdateRequest
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsUpdateRequest
     */
    'linkoutUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsUpdateRequest
     */
    'referencedComment'?: string;
    /**
     * 
     * @type {Array<TruckTourCommentsUpdateRequestImageListInner>}
     * @memberof TruckTourCommentsUpdateRequest
     */
    'imageList'?: Array<TruckTourCommentsUpdateRequestImageListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof TruckTourCommentsUpdateRequest
     */
    'deleteImage'?: boolean;
}
/**
 * 
 * @export
 * @interface TruckTourCommentsUpdateRequestImageListInner
 */
export interface TruckTourCommentsUpdateRequestImageListInner {
    /**
     * 
     * @type {number}
     * @memberof TruckTourCommentsUpdateRequestImageListInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourCommentsUpdateRequestImageListInner
     */
    'key'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TruckTourCommentsUpdateRequestImageListInner
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @interface TruckTourGlobalConfigsIndex200Response
 */
export interface TruckTourGlobalConfigsIndex200Response {
    /**
     * 
     * @type {Array<CoreGlobalConfigItem>}
     * @memberof TruckTourGlobalConfigsIndex200Response
     */
    'configs': Array<CoreGlobalConfigItem>;
}
/**
 * 
 * @export
 * @interface TruckTourLiveIndex200Response
 */
export interface TruckTourLiveIndex200Response {
    /**
     * 
     * @type {Array<TruckStopConfig>}
     * @memberof TruckTourLiveIndex200Response
     */
    'configs': Array<TruckStopConfig>;
    /**
     * 
     * @type {Array<TruckStop>}
     * @memberof TruckTourLiveIndex200Response
     */
    'trucks': Array<TruckStop>;
    /**
     * 
     * @type {Array<TruckTourLiveIndex200ResponseStopsInner>}
     * @memberof TruckTourLiveIndex200Response
     */
    'stops': Array<TruckTourLiveIndex200ResponseStopsInner>;
}
/**
 * 
 * @export
 * @interface TruckTourLiveIndex200ResponseStopsInner
 */
export interface TruckTourLiveIndex200ResponseStopsInner {
    /**
     * 
     * @type {Array<TruckStopChip>}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'chips'?: Array<TruckStopChip>;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'displayDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'application'?: TruckStopApplication;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'mapBadge'?: TruckBadge;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'sheetBadge'?: TruckBadge;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'information'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'lotteryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'maxLotteryWinCount'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'lotteryState'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'communityFeedUrl'?: string | null;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'media'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'merch'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'type'?: TruckTourLiveIndex200ResponseStopsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TruckTourLiveIndex200ResponseStopsInner
     */
    'state'?: TruckTourLiveIndex200ResponseStopsInnerStateEnum;
}

export const TruckTourLiveIndex200ResponseStopsInnerTypeEnum = {
    Public: 'public',
    Truck: 'truck',
    Private: 'private'
} as const;

export type TruckTourLiveIndex200ResponseStopsInnerTypeEnum = typeof TruckTourLiveIndex200ResponseStopsInnerTypeEnum[keyof typeof TruckTourLiveIndex200ResponseStopsInnerTypeEnum];
export const TruckTourLiveIndex200ResponseStopsInnerStateEnum = {
    Live: 'live',
    Unconfirmed: 'unconfirmed',
    Upcoming: 'upcoming',
    Countdown: 'countdown',
    Ended: 'ended',
    Cancelled: 'cancelled',
    Delayed: 'delayed'
} as const;

export type TruckTourLiveIndex200ResponseStopsInnerStateEnum = typeof TruckTourLiveIndex200ResponseStopsInnerStateEnum[keyof typeof TruckTourLiveIndex200ResponseStopsInnerStateEnum];

/**
 * 
 * @export
 * @interface TruckTourLotteryEventsIndex200Response
 */
export interface TruckTourLotteryEventsIndex200Response {
    /**
     * 
     * @type {Array<LotteryStop>}
     * @memberof TruckTourLotteryEventsIndex200Response
     */
    'events'?: Array<LotteryStop>;
}
/**
 * 
 * @export
 * @interface TruckTourMediaCreate200Response
 */
export interface TruckTourMediaCreate200Response {
    /**
     * 
     * @type {string}
     * @memberof TruckTourMediaCreate200Response
     */
    'key': string;
    /**
     * 
     * @type {number}
     * @memberof TruckTourMediaCreate200Response
     */
    'bucket': number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourMediaCreate200Response
     */
    'thumbnail'?: string;
    /**
     * this property will be available for videos only
     * @type {string}
     * @memberof TruckTourMediaCreate200Response
     */
    'videoThumbnailUrl'?: string;
}
/**
 * 
 * @export
 * @interface TruckTourMediaCreate400Response
 */
export interface TruckTourMediaCreate400Response {
    /**
     * 
     * @type {object}
     * @memberof TruckTourMediaCreate400Response
     */
    'errors': object;
}
/**
 * 
 * @export
 * @interface TruckTourMediaCreate404Response
 */
export interface TruckTourMediaCreate404Response {
    /**
     * 
     * @type {string}
     * @memberof TruckTourMediaCreate404Response
     */
    'errors': string;
}
/**
 * Post item response
 * @export
 * @interface TruckTourPost
 */
export interface TruckTourPost {
    /**
     * 
     * @type {string}
     * @memberof TruckTourPost
     */
    'id': string;
    /**
     * 
     * @type {TruckTourPostGroup}
     * @memberof TruckTourPost
     */
    'group': TruckTourPostGroup | null;
    /**
     * 
     * @type {TruckStopUser}
     * @memberof TruckTourPost
     */
    'user': TruckStopUser;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPost
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPost
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPost
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPost
     */
    'oldLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPost
     */
    'location'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TruckTourPost
     */
    'geoLat'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TruckTourPost
     */
    'geoLong'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TruckTourPost
     */
    'commentCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckTourPost
     */
    'viewCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TruckTourPost
     */
    'images'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TruckTourPost
     */
    'videos'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TruckTourPost
     */
    'isMediaUnderProcessing'?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof TruckTourPost
     */
    'reactionCount'?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof TruckTourPost
     */
    'totalReactionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TruckTourPost
     */
    'reactionCountSum'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPost
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TruckTourPost
     */
    'isHighlighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TruckTourPost
     */
    'isEditorial'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPost
     */
    'type': string;
    /**
     * 
     * @type {object}
     * @memberof TruckTourPost
     */
    'latestComment'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPost
     */
    'pollType'?: string | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof TruckTourPost
     */
    'pollOptions'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPost
     */
    'pollClosedAt'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof TruckTourPost
     */
    'poll'?: object | null;
}
/**
 * group for truck tour post creation
 * @export
 * @interface TruckTourPostGroup
 */
export interface TruckTourPostGroup {
    /**
     * 
     * @type {number}
     * @memberof TruckTourPostGroup
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPostGroup
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPostGroup
     */
    'subline': string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPostGroup
     */
    'image': string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPostGroup
     */
    'imageAuthorAttribution'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourPostGroup
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface TruckTourPostReactionOutput
 */
export interface TruckTourPostReactionOutput {
    /**
     * 
     * @type {string}
     * @memberof TruckTourPostReactionOutput
     */
    'message'?: string;
    /**
     * 
     * @type {TruckTourPostReactionOutputPostReactions}
     * @memberof TruckTourPostReactionOutput
     */
    'postReactions'?: TruckTourPostReactionOutputPostReactions;
}
/**
 * 
 * @export
 * @interface TruckTourPostReactionOutputPostReactions
 */
export interface TruckTourPostReactionOutputPostReactions {
    /**
     * 
     * @type {Array<TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsUserReactionsInner>}
     * @memberof TruckTourPostReactionOutputPostReactions
     */
    'userReactions'?: Array<TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsUserReactionsInner>;
    /**
     * 
     * @type {TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsReactionCount}
     * @memberof TruckTourPostReactionOutputPostReactions
     */
    'reactionCount'?: TruckTourCommentsReactionCreate201ResponseInnerCommentReactionsReactionCount;
    /**
     * 
     * @type {number}
     * @memberof TruckTourPostReactionOutputPostReactions
     */
    'totalReactionCount'?: number;
}
/**
 * 
 * @export
 * @interface TruckTourPostSuggestedStopsIndex200Response
 */
export interface TruckTourPostSuggestedStopsIndex200Response {
    /**
     * 
     * @type {Array<PostSuggestedStop>}
     * @memberof TruckTourPostSuggestedStopsIndex200Response
     */
    'suggestedStops'?: Array<PostSuggestedStop>;
}
/**
 * 
 * @export
 * @interface TruckTourPostsCreate401Response
 */
export interface TruckTourPostsCreate401Response {
    /**
     * Wrong or Expired Session
     * @type {string}
     * @memberof TruckTourPostsCreate401Response
     */
    'errors': string;
}
/**
 * 
 * @export
 * @interface TruckTourPostsDelete200Response
 */
export interface TruckTourPostsDelete200Response {
    /**
     * 
     * @type {string}
     * @memberof TruckTourPostsDelete200Response
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface TruckTourPostsDetailsShow200Response
 */
export interface TruckTourPostsDetailsShow200Response {
    /**
     * 
     * @type {TruckTourPost}
     * @memberof TruckTourPostsDetailsShow200Response
     */
    'post'?: TruckTourPost;
}
/**
 * 
 * @export
 * @interface TruckTourPostsIndex200Response
 */
export interface TruckTourPostsIndex200Response {
    /**
     * 
     * @type {Array<TruckTourPost>}
     * @memberof TruckTourPostsIndex200Response
     */
    'posts'?: Array<TruckTourPost>;
}
/**
 * 
 * @export
 * @interface TruckTourPostsReactionCreate400Response
 */
export interface TruckTourPostsReactionCreate400Response {
    /**
     * 
     * @type {object}
     * @memberof TruckTourPostsReactionCreate400Response
     */
    'reactionTypeName'?: object;
}
/**
 * 
 * @export
 * @interface TruckTourPostsReactionDelete200ResponseInner
 */
export interface TruckTourPostsReactionDelete200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof TruckTourPostsReactionDelete200ResponseInner
     */
    'message'?: string;
    /**
     * 
     * @type {TruckTourCommentsReactionCreate201ResponseInnerCommentReactions}
     * @memberof TruckTourPostsReactionDelete200ResponseInner
     */
    'storyReactions'?: TruckTourCommentsReactionCreate201ResponseInnerCommentReactions;
}
/**
 * 
 * @export
 * @interface TruckTourPostsShow200Response
 */
export interface TruckTourPostsShow200Response {
    /**
     * 
     * @type {TruckStopMediaItem}
     * @memberof TruckTourPostsShow200Response
     */
    'media'?: TruckStopMediaItem | null;
}
/**
 * 
 * @export
 * @interface TruckTourReportsClassificationIndex200ResponseInner
 */
export interface TruckTourReportsClassificationIndex200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof TruckTourReportsClassificationIndex200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourReportsClassificationIndex200ResponseInner
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TruckTourReportsClassificationIndex400Response
 */
export interface TruckTourReportsClassificationIndex400Response {
    /**
     * 
     * @type {TruckTourReportsClassificationIndex400ResponseErrors}
     * @memberof TruckTourReportsClassificationIndex400Response
     */
    'errors'?: TruckTourReportsClassificationIndex400ResponseErrors;
}
/**
 * 
 * @export
 * @interface TruckTourReportsClassificationIndex400ResponseErrors
 */
export interface TruckTourReportsClassificationIndex400ResponseErrors {
    /**
     * 
     * @type {string}
     * @memberof TruckTourReportsClassificationIndex400ResponseErrors
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface TruckTourRouteShow200Response
 */
export interface TruckTourRouteShow200Response {
    /**
     * 
     * @type {Array<TruckStopConfig>}
     * @memberof TruckTourRouteShow200Response
     */
    'configs': Array<TruckStopConfig>;
    /**
     * 
     * @type {TruckTourRouteShow200ResponseStop}
     * @memberof TruckTourRouteShow200Response
     */
    'stop': TruckTourRouteShow200ResponseStop;
}
/**
 * 
 * @export
 * @interface TruckTourRouteShow200ResponseStop
 */
export interface TruckTourRouteShow200ResponseStop {
    /**
     * 
     * @type {Array<TruckStopChip>}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'chips'?: Array<TruckStopChip>;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'displayDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'application'?: TruckStopApplication;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'mapBadge'?: TruckBadge;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'sheetBadge'?: TruckBadge;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'information'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'lotteryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'maxLotteryWinCount'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'lotteryState'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'communityFeedUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'state'?: TruckTourRouteShow200ResponseStopStateEnum;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'media'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'garageLocation'?: TruckStopLocation;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'type'?: TruckTourRouteShow200ResponseStopTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'stopId'?: string | null;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof TruckTourRouteShow200ResponseStop
     */
    'merch'?: Array<TruckStopMediaItem>;
}

export const TruckTourRouteShow200ResponseStopStateEnum = {
    Live: 'live',
    Unconfirmed: 'unconfirmed',
    Upcoming: 'upcoming',
    Countdown: 'countdown',
    Ended: 'ended',
    Cancelled: 'cancelled',
    Delayed: 'delayed'
} as const;

export type TruckTourRouteShow200ResponseStopStateEnum = typeof TruckTourRouteShow200ResponseStopStateEnum[keyof typeof TruckTourRouteShow200ResponseStopStateEnum];
export const TruckTourRouteShow200ResponseStopTypeEnum = {
    Public: 'public',
    Truck: 'truck',
    Private: 'private'
} as const;

export type TruckTourRouteShow200ResponseStopTypeEnum = typeof TruckTourRouteShow200ResponseStopTypeEnum[keyof typeof TruckTourRouteShow200ResponseStopTypeEnum];

/**
 * 
 * @export
 * @interface TruckTourSearchApplicationsIndex200Response
 */
export interface TruckTourSearchApplicationsIndex200Response {
    /**
     * 
     * @type {Array<TruckStopConfig>}
     * @memberof TruckTourSearchApplicationsIndex200Response
     */
    'configs': Array<TruckStopConfig>;
    /**
     * 
     * @type {number}
     * @memberof TruckTourSearchApplicationsIndex200Response
     */
    'total': number;
    /**
     * 
     * @type {Array<TruckSearchStop>}
     * @memberof TruckTourSearchApplicationsIndex200Response
     */
    'stops': Array<TruckSearchStop>;
}
/**
 * 
 * @export
 * @interface TruckTourStreamCommentsCreate200Response
 */
export interface TruckTourStreamCommentsCreate200Response {
    /**
     * 
     * @type {TruckStopComment}
     * @memberof TruckTourStreamCommentsCreate200Response
     */
    'comment'?: TruckStopComment;
}
/**
 * 
 * @export
 * @interface TruckTourStreamCommentsIndex200Response
 */
export interface TruckTourStreamCommentsIndex200Response {
    /**
     * 
     * @type {TruckStopUser}
     * @memberof TruckTourStreamCommentsIndex200Response
     */
    'user'?: TruckStopUser | null;
    /**
     * 
     * @type {TruckStopMediaItem}
     * @memberof TruckTourStreamCommentsIndex200Response
     */
    'media'?: TruckStopMediaItem;
    /**
     * 
     * @type {Array<TruckStopComment>}
     * @memberof TruckTourStreamCommentsIndex200Response
     */
    'comments'?: Array<TruckStopComment>;
}
/**
 * 
 * @export
 * @interface TruckTourUserConfigIndex200Response
 */
export interface TruckTourUserConfigIndex200Response {
    /**
     * List of application IDs associated with the user
     * @type {Array<string>}
     * @memberof TruckTourUserConfigIndex200Response
     */
    'applications': Array<string>;
}
/**
 * 
 * @export
 * @interface TruckTourUserProfileIndex200Response
 */
export interface TruckTourUserProfileIndex200Response {
    /**
     * 
     * @type {string}
     * @memberof TruckTourUserProfileIndex200Response
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourUserProfileIndex200Response
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourUserProfileIndex200Response
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourUserProfileIndex200Response
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourUserProfileIndex200Response
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TruckTourUserProfileIndex200Response
     */
    'fallbackAvatar'?: string;
    /**
     * 
     * @type {PrivacySettings}
     * @memberof TruckTourUserProfileIndex200Response
     */
    'privacySettings'?: PrivacySettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof TruckTourUserProfileIndex200Response
     */
    'notificationSettings'?: NotificationSettings;
    /**
     * 
     * @type {SessionUserStatistics}
     * @memberof TruckTourUserProfileIndex200Response
     */
    'statistics'?: SessionUserStatistics;
    /**
     * 
     * @type {TruckTourUserProfileIndex200ResponseAllOfInteractions}
     * @memberof TruckTourUserProfileIndex200Response
     */
    'interactions'?: TruckTourUserProfileIndex200ResponseAllOfInteractions;
}
/**
 * 
 * @export
 * @interface TruckTourUserProfileIndex200ResponseAllOfInteractions
 */
export interface TruckTourUserProfileIndex200ResponseAllOfInteractions {
    /**
     * 
     * @type {Array<object>}
     * @memberof TruckTourUserProfileIndex200ResponseAllOfInteractions
     */
    'polls'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof TruckTourUserProfileIndex200ResponseAllOfInteractions
     */
    'reactions'?: Array<object>;
}
/**
 * 
 * @export
 * @interface TuckTourRoutesIndex200Response
 */
export interface TuckTourRoutesIndex200Response {
    /**
     * 
     * @type {number}
     * @memberof TuckTourRoutesIndex200Response
     */
    'total': number;
    /**
     * 
     * @type {Array<TruckStopConfig>}
     * @memberof TuckTourRoutesIndex200Response
     */
    'configs': Array<TruckStopConfig>;
    /**
     * 
     * @type {Array<TuckTourRoutesIndex200ResponseStopsInner>}
     * @memberof TuckTourRoutesIndex200Response
     */
    'stops': Array<TuckTourRoutesIndex200ResponseStopsInner>;
}
/**
 * 
 * @export
 * @interface TuckTourRoutesIndex200ResponseStopsInner
 */
export interface TuckTourRoutesIndex200ResponseStopsInner {
    /**
     * 
     * @type {Array<TruckStopChip>}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'chips'?: Array<TruckStopChip>;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'displayDate'?: string | null;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'location'?: TruckStopLocation;
    /**
     * 
     * @type {TruckStopApplication}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'application'?: TruckStopApplication;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'mapBadge'?: TruckBadge;
    /**
     * 
     * @type {TruckBadge}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'sheetBadge'?: TruckBadge;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'information'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'linkoutUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'lotteryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'maxLotteryWinCount'?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'lotteryState'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'communityFeedUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'state'?: TuckTourRoutesIndex200ResponseStopsInnerStateEnum;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'media'?: Array<TruckStopMediaItem>;
    /**
     * 
     * @type {TruckStopLocation}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'garageLocation'?: TruckStopLocation;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'type'?: TuckTourRoutesIndex200ResponseStopsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'stopId'?: string | null;
    /**
     * 
     * @type {Array<TruckStopMediaItem>}
     * @memberof TuckTourRoutesIndex200ResponseStopsInner
     */
    'merch'?: Array<TruckStopMediaItem>;
}

export const TuckTourRoutesIndex200ResponseStopsInnerStateEnum = {
    Live: 'live',
    Unconfirmed: 'unconfirmed',
    Upcoming: 'upcoming',
    Countdown: 'countdown',
    Ended: 'ended',
    Cancelled: 'cancelled',
    Delayed: 'delayed'
} as const;

export type TuckTourRoutesIndex200ResponseStopsInnerStateEnum = typeof TuckTourRoutesIndex200ResponseStopsInnerStateEnum[keyof typeof TuckTourRoutesIndex200ResponseStopsInnerStateEnum];
export const TuckTourRoutesIndex200ResponseStopsInnerTypeEnum = {
    Public: 'public',
    Truck: 'truck',
    Private: 'private'
} as const;

export type TuckTourRoutesIndex200ResponseStopsInnerTypeEnum = typeof TuckTourRoutesIndex200ResponseStopsInnerTypeEnum[keyof typeof TuckTourRoutesIndex200ResponseStopsInnerTypeEnum];

/**
 * User object
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'avatar'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'activeState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'allowToContact'?: boolean;
}
/**
 * User achievement object
 * @export
 * @interface UserAchievement
 */
export interface UserAchievement {
    /**
     * 
     * @type {string}
     * @memberof UserAchievement
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof UserAchievement
     */
    'criteria': number;
    /**
     * 
     * @type {string}
     * @memberof UserAchievement
     */
    'label': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAchievement
     */
    'isEarned': boolean;
    /**
     * 
     * @type {number}
     * @memberof UserAchievement
     */
    'totalUsersCount': number;
}
/**
 * user chat message
 * @export
 * @interface UserChatMessage
 */
export interface UserChatMessage {
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'key': string;
    /**
     * 
     * @type {ChatConversationParticipant}
     * @memberof UserChatMessage
     */
    'createdBy': ChatConversationParticipant;
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'linkoutUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof UserChatMessage
     */
    'sentAt': number;
    /**
     * 
     * @type {number}
     * @memberof UserChatMessage
     */
    'updatedAt': number | null;
    /**
     * 
     * @type {Array<Image>}
     * @memberof UserChatMessage
     */
    'images': Array<Image>;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isEdited': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserChatMessage
     */
    'type': UserChatMessageTypeEnum;
    /**
     * 
     * @type {ReferencedMessage}
     * @memberof UserChatMessage
     */
    'referencedMessage': ReferencedMessage;
    /**
     * 
     * @type {boolean}
     * @memberof UserChatMessage
     */
    'isSeen': boolean;
    /**
     * 
     * @type {Array<ChatConversationParticipant>}
     * @memberof UserChatMessage
     */
    'seenBy': Array<ChatConversationParticipant>;
    /**
     * 
     * @type {ChatMessageAllOfReactionCount}
     * @memberof UserChatMessage
     */
    'reactionCount': ChatMessageAllOfReactionCount | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserChatMessage
     */
    'userReactions'?: Array<string>;
}

export const UserChatMessageTypeEnum = {
    SystemConversationArchived: 'system-conversation-archived',
    SystemConversationCreated: 'system-conversation-created',
    SystemConversationReopened: 'system-conversation-reopened',
    SystemConversationRejoined: 'system-conversation-rejoined',
    SystemConversationTitle: 'system-conversation-title',
    SystemOwnerChanged: 'system-owner-changed',
    SystemParticipantLeft: 'system-participant-left',
    SystemParticipantsAdded: 'system-participants-added',
    SystemParticipantsRemoved: 'system-participants-removed',
    Message: 'message'
} as const;

export type UserChatMessageTypeEnum = typeof UserChatMessageTypeEnum[keyof typeof UserChatMessageTypeEnum];

/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {number}
     * @memberof UserInfo
     */
    'ssoId'?: number;
    /**
     * 
     * @type {Array<BookingInfo>}
     * @memberof UserInfo
     */
    'bookings'?: Array<BookingInfo>;
}
/**
 * 
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     * 
     * @type {User}
     * @memberof UserProfile
     */
    'user': User;
    /**
     * 
     * @type {UserRelationMetadata}
     * @memberof UserProfile
     */
    'metadata': UserRelationMetadata | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'reverseRelationState': UserProfileReverseRelationStateEnum | null;
}

export const UserProfileReverseRelationStateEnum = {
    Active: 'active',
    Blocked: 'blocked',
    None: 'none'
} as const;

export type UserProfileReverseRelationStateEnum = typeof UserProfileReverseRelationStateEnum[keyof typeof UserProfileReverseRelationStateEnum];

/**
 * 
 * @export
 * @interface UserRelationMetadata
 */
export interface UserRelationMetadata {
    /**
     * 
     * @type {string}
     * @memberof UserRelationMetadata
     */
    'source'?: UserRelationMetadataSourceEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UserRelationMetadata
     */
    'sourceType': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRelationMetadata
     */
    'sourceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRelationMetadata
     */
    'sourceName': string | null;
}

export const UserRelationMetadataSourceEnum = {
    Chat: 'chat',
    Group: 'group',
    Profile: 'profile'
} as const;

export type UserRelationMetadataSourceEnum = typeof UserRelationMetadataSourceEnum[keyof typeof UserRelationMetadataSourceEnum];

/**
 * Relationship details between two users
 * @export
 * @interface UserRelationship
 */
export interface UserRelationship {
    /**
     * 
     * @type {string}
     * @memberof UserRelationship
     */
    'state': UserRelationshipStateEnum;
    /**
     * 
     * @type {UserRelationMetadata}
     * @memberof UserRelationship
     */
    'metadata': UserRelationMetadata | null;
}

export const UserRelationshipStateEnum = {
    Active: 'active',
    Blocked: 'blocked',
    None: 'none'
} as const;

export type UserRelationshipStateEnum = typeof UserRelationshipStateEnum[keyof typeof UserRelationshipStateEnum];

/**
 * Relationship details between two users
 * @export
 * @interface UserRelationshipResult
 */
export interface UserRelationshipResult {
    /**
     * 
     * @type {UserRelationship}
     * @memberof UserRelationshipResult
     */
    'subject': UserRelationship;
    /**
     * 
     * @type {UserRelationship}
     * @memberof UserRelationshipResult
     */
    'follower': UserRelationship;
    /**
     * 
     * @type {User}
     * @memberof UserRelationshipResult
     */
    'user': User;
}
/**
 * User statistics object
 * @export
 * @interface UserStatistics
 */
export interface UserStatistics {
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'contributionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'postsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'commentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'likesGivenCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'likesReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserStatistics
     */
    'groupsJoinedCount'?: number;
}
/**
 * 
 * @export
 * @interface WidgetOutput
 */
export interface WidgetOutput {
    /**
     * 
     * @type {string}
     * @memberof WidgetOutput
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetOutput
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetOutput
     */
    'ctaUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetOutput
     */
    'ctaText'?: string;
    /**
     * 
     * @type {Array<TruckStopWidget>}
     * @memberof WidgetOutput
     */
    'stops'?: Array<TruckStopWidget>;
    /**
     * 
     * @type {Array<TruckStopBanner>}
     * @memberof WidgetOutput
     */
    'banners'?: Array<TruckStopBanner>;
}

/**
 * TruckTourApi - axios parameter creator
 * @export
 */
export const TruckTourApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Validate authentication of the c24 session for Truck
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourAuthValidateIndex: async (c24session?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/external/truck-tour/auth/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new truck tour comment
         * @param {string} uuid uuid of the content
         * @param {TruckTourCommentsCreateRequest} [truckTourCommentsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsCreate: async (uuid: string, truckTourCommentsCreateRequest?: TruckTourCommentsCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourCommentsCreate', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/comments`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(truckTourCommentsCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a truck tour comment
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsDelete: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourCommentsDelete', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/comments/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create comment reaction
         * @param {string} uuid uuid of the content
         * @param {string} c24session 
         * @param {TruckTourCommentsReactionCreateRequest} [truckTourCommentsReactionCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsReactionCreate: async (uuid: string, c24session: string, truckTourCommentsReactionCreateRequest?: TruckTourCommentsReactionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourCommentsReactionCreate', 'uuid', uuid)
            // verify required parameter 'c24session' is not null or undefined
            assertParamExists('truckTourCommentsReactionCreate', 'c24session', c24session)
            const localVarPath = `/v1/external/truck-tour/comments/{uuid}/reaction`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(truckTourCommentsReactionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete comment reaction
         * @param {string} uuid id of the comment to remove its reaction
         * @param {string} reactionTypeName reaction type name to react with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsReactionDelete: async (uuid: string, reactionTypeName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourCommentsReactionDelete', 'uuid', uuid)
            // verify required parameter 'reactionTypeName' is not null or undefined
            assertParamExists('truckTourCommentsReactionDelete', 'reactionTypeName', reactionTypeName)
            const localVarPath = `/v1/external/truck-tour/comments/{uuid}/reaction/{reactionTypeName}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"reactionTypeName"}}`, encodeURIComponent(String(reactionTypeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report a truck tour comment
         * @param {string} uuid uuid of the content
         * @param {TruckTourCommentsReportCreateRequest} [truckTourCommentsReportCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsReportCreate: async (uuid: string, truckTourCommentsReportCreateRequest?: TruckTourCommentsReportCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourCommentsReportCreate', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/comments/{uuid}/report`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(truckTourCommentsReportCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsShow: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourCommentsShow', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/comments/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a truck tour comment
         * @param {string} uuid uuid of the content
         * @param {TruckTourCommentsUpdateRequest} [truckTourCommentsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsUpdate: async (uuid: string, truckTourCommentsUpdateRequest?: TruckTourCommentsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourCommentsUpdate', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/comments/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(truckTourCommentsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourGlobalConfigsIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/external/truck-tour/global-configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourLiveIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/external/truck-tour/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourLotteryEventsIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/external/truck-tour/lottery/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create media for truck tour
         * @param {string} media 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourMediaCreate: async (media: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'media' is not null or undefined
            assertParamExists('truckTourMediaCreate', 'media', media)
            const localVarPath = `/v1/external/truck-tour/media`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (media !== undefined) { 
                localVarFormParams.append('media', media as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostSuggestedStopsIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/external/truck-tour/posts/suggested-stops`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * list post comments
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsCommentsIndex: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourPostsCommentsIndex', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/posts/{uuid}/comments`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a post for a truck tour stop
         * @param {string} id id of the post stop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsCreate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('truckTourPostsCreate', 'id', id)
            const localVarPath = `/v1/external/truck-tour/stops/{id}/posts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single post for Truck Tour
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsDelete: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourPostsDelete', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/posts/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsDetailsShow: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourPostsDetailsShow', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/posts/{uuid}/details`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] number of posts in page
         * @param {CursorParam} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsIndex: async (limit?: number, cursor?: CursorParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/external/truck-tour/stops/{id}/posts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                for (const [key, value] of Object.entries(cursor)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create post reaction
         * @param {string} uuid uuid of the content
         * @param {string} c24session 
         * @param {TruckTourCommentsReactionCreateRequest} [truckTourCommentsReactionCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsReactionCreate: async (uuid: string, c24session: string, truckTourCommentsReactionCreateRequest?: TruckTourCommentsReactionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourPostsReactionCreate', 'uuid', uuid)
            // verify required parameter 'c24session' is not null or undefined
            assertParamExists('truckTourPostsReactionCreate', 'c24session', c24session)
            const localVarPath = `/v1/external/truck-tour/posts/{uuid}/reaction`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(truckTourCommentsReactionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete post reaction
         * @param {string} uuid uuid of the content
         * @param {string} reactionTypeName reaction type name to react with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsReactionDelete: async (uuid: string, reactionTypeName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourPostsReactionDelete', 'uuid', uuid)
            // verify required parameter 'reactionTypeName' is not null or undefined
            assertParamExists('truckTourPostsReactionDelete', 'reactionTypeName', reactionTypeName)
            const localVarPath = `/v1/external/truck-tour/posts/{uuid}/reaction/{reactionTypeName}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"reactionTypeName"}}`, encodeURIComponent(String(reactionTypeName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report on a single post for breaching the truck tour guidelines
         * @param {string} uuid uuid of the content
         * @param {TruckTourCommentsReportCreateRequest} [truckTourCommentsReportCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsReportCreate: async (uuid: string, truckTourCommentsReportCreateRequest?: TruckTourCommentsReportCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourPostsReportCreate', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/posts/{uuid}/report`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(truckTourCommentsReportCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsShow: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourPostsShow', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/posts/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a truck tour post
         * @param {string} uuid uuid of the truck tour post to be edited
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsUpdate: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourPostsUpdate', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/posts/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve report classifications by provided report classification type
         * @param {TruckTourReportsClassificationIndexReportClassTypeEnum} reportClassType report classification type
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourReportsClassificationIndex: async (reportClassType: TruckTourReportsClassificationIndexReportClassTypeEnum, c24session?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportClassType' is not null or undefined
            assertParamExists('truckTourReportsClassificationIndex', 'reportClassType', reportClassType)
            const localVarPath = `/v1/external/truck-tour/reports/{reportClassType}/classifications`
                .replace(`{${"reportClassType"}}`, encodeURIComponent(String(reportClassType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id id of the entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourRouteShow: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('truckTourRouteShow', 'id', id)
            const localVarPath = `/v1/external/truck-tour/route/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourSearchApplicationsIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/external/truck-tour/search/applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourStreamCommentsCreate: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourStreamCommentsCreate', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/stream/{uuid}/comments`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourStreamCommentsIndex: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('truckTourStreamCommentsIndex', 'uuid', uuid)
            const localVarPath = `/v1/external/truck-tour/stream/{uuid}/comments`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get truck tour user configuration settings
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourUserConfigIndex: async (c24session?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/external/truck-tour/user/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get truck tour user profile
         * @param {string} c24session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourUserProfileIndex: async (c24session: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'c24session' is not null or undefined
            assertParamExists('truckTourUserProfileIndex', 'c24session', c24session)
            const localVarPath = `/v1/external/truck-tour/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourWidgetsIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/external/truck-tour/widgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tuckTourRoutesIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/external/truck-tour/route`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TruckTourApi - functional programming interface
 * @export
 */
export const TruckTourApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TruckTourApiAxiosParamCreator(configuration)
    return {
        /**
         * Validate authentication of the c24 session for Truck
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourAuthValidateIndex(c24session?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourAuthValidateIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourAuthValidateIndex(c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourAuthValidateIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new truck tour comment
         * @param {string} uuid uuid of the content
         * @param {TruckTourCommentsCreateRequest} [truckTourCommentsCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourCommentsCreate(uuid: string, truckTourCommentsCreateRequest?: TruckTourCommentsCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokCommentWithSuspendedDeleted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourCommentsCreate(uuid, truckTourCommentsCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourCommentsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a truck tour comment
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourCommentsDelete(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokCommentWithSuspendedDeleted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourCommentsDelete(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourCommentsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create comment reaction
         * @param {string} uuid uuid of the content
         * @param {string} c24session 
         * @param {TruckTourCommentsReactionCreateRequest} [truckTourCommentsReactionCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourCommentsReactionCreate(uuid: string, c24session: string, truckTourCommentsReactionCreateRequest?: TruckTourCommentsReactionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TruckTourCommentsReactionCreate201ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourCommentsReactionCreate(uuid, c24session, truckTourCommentsReactionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourCommentsReactionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete comment reaction
         * @param {string} uuid id of the comment to remove its reaction
         * @param {string} reactionTypeName reaction type name to react with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourCommentsReactionDelete(uuid: string, reactionTypeName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TruckTourCommentsReactionCreate201ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourCommentsReactionDelete(uuid, reactionTypeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourCommentsReactionDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report a truck tour comment
         * @param {string} uuid uuid of the content
         * @param {TruckTourCommentsReportCreateRequest} [truckTourCommentsReportCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourCommentsReportCreate(uuid: string, truckTourCommentsReportCreateRequest?: TruckTourCommentsReportCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokCommentWithSuspendedDeleted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourCommentsReportCreate(uuid, truckTourCommentsReportCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourCommentsReportCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourCommentsShow(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokCommentWithSuspendedDeleted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourCommentsShow(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourCommentsShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a truck tour comment
         * @param {string} uuid uuid of the content
         * @param {TruckTourCommentsUpdateRequest} [truckTourCommentsUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourCommentsUpdate(uuid: string, truckTourCommentsUpdateRequest?: TruckTourCommentsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecktokCommentWithSuspendedDeleted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourCommentsUpdate(uuid, truckTourCommentsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourCommentsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourGlobalConfigsIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourGlobalConfigsIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourGlobalConfigsIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourGlobalConfigsIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourLiveIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourLiveIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourLiveIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourLiveIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourLotteryEventsIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourLotteryEventsIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourLotteryEventsIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourLotteryEventsIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create media for truck tour
         * @param {string} media 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourMediaCreate(media: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourMediaCreate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourMediaCreate(media, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourMediaCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostSuggestedStopsIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourPostSuggestedStopsIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostSuggestedStopsIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostSuggestedStopsIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * list post comments
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostsCommentsIndex(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChecktokCommentWithSuspendedDeleted>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostsCommentsIndex(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostsCommentsIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a post for a truck tour stop
         * @param {string} id id of the post stop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostsCreate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostsCreate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a single post for Truck Tour
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostsDelete(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourPostsDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostsDelete(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostsDetailsShow(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourPostsDetailsShow200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostsDetailsShow(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostsDetailsShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] number of posts in page
         * @param {CursorParam} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostsIndex(limit?: number, cursor?: CursorParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourPostsIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostsIndex(limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostsIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * create post reaction
         * @param {string} uuid uuid of the content
         * @param {string} c24session 
         * @param {TruckTourCommentsReactionCreateRequest} [truckTourCommentsReactionCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostsReactionCreate(uuid: string, c24session: string, truckTourCommentsReactionCreateRequest?: TruckTourCommentsReactionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourPostReactionOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostsReactionCreate(uuid, c24session, truckTourCommentsReactionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostsReactionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * delete post reaction
         * @param {string} uuid uuid of the content
         * @param {string} reactionTypeName reaction type name to react with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostsReactionDelete(uuid: string, reactionTypeName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TruckTourPostsReactionDelete200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostsReactionDelete(uuid, reactionTypeName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostsReactionDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report on a single post for breaching the truck tour guidelines
         * @param {string} uuid uuid of the content
         * @param {TruckTourCommentsReportCreateRequest} [truckTourCommentsReportCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostsReportCreate(uuid: string, truckTourCommentsReportCreateRequest?: TruckTourCommentsReportCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostsReportCreate(uuid, truckTourCommentsReportCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostsReportCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostsShow(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourPostsShow200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostsShow(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostsShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a truck tour post
         * @param {string} uuid uuid of the truck tour post to be edited
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourPostsUpdate(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourPostsUpdate(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourPostsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve report classifications by provided report classification type
         * @param {TruckTourReportsClassificationIndexReportClassTypeEnum} reportClassType report classification type
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourReportsClassificationIndex(reportClassType: TruckTourReportsClassificationIndexReportClassTypeEnum, c24session?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TruckTourReportsClassificationIndex200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourReportsClassificationIndex(reportClassType, c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourReportsClassificationIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id id of the entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourRouteShow(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourRouteShow200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourRouteShow(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourRouteShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourSearchApplicationsIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourSearchApplicationsIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourSearchApplicationsIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourSearchApplicationsIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourStreamCommentsCreate(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourStreamCommentsCreate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourStreamCommentsCreate(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourStreamCommentsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid uuid of the content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourStreamCommentsIndex(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourStreamCommentsIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourStreamCommentsIndex(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourStreamCommentsIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get truck tour user configuration settings
         * @param {string} [c24session] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourUserConfigIndex(c24session?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourUserConfigIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourUserConfigIndex(c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourUserConfigIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get truck tour user profile
         * @param {string} c24session 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourUserProfileIndex(c24session: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckTourUserProfileIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourUserProfileIndex(c24session, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourUserProfileIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async truckTourWidgetsIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WidgetOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.truckTourWidgetsIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.truckTourWidgetsIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tuckTourRoutesIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TuckTourRoutesIndex200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tuckTourRoutesIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckTourApi.tuckTourRoutesIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TruckTourApi - factory interface
 * @export
 */
export const TruckTourApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TruckTourApiFp(configuration)
    return {
        /**
         * Validate authentication of the c24 session for Truck
         * @param {TruckTourApiTruckTourAuthValidateIndexRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourAuthValidateIndex(requestParameters: TruckTourApiTruckTourAuthValidateIndexRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourAuthValidateIndex200Response> {
            return localVarFp.truckTourAuthValidateIndex(requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new truck tour comment
         * @param {TruckTourApiTruckTourCommentsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsCreate(requestParameters: TruckTourApiTruckTourCommentsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokCommentWithSuspendedDeleted> {
            return localVarFp.truckTourCommentsCreate(requestParameters.uuid, requestParameters.truckTourCommentsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a truck tour comment
         * @param {TruckTourApiTruckTourCommentsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsDelete(requestParameters: TruckTourApiTruckTourCommentsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokCommentWithSuspendedDeleted> {
            return localVarFp.truckTourCommentsDelete(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * create comment reaction
         * @param {TruckTourApiTruckTourCommentsReactionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsReactionCreate(requestParameters: TruckTourApiTruckTourCommentsReactionCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TruckTourCommentsReactionCreate201ResponseInner>> {
            return localVarFp.truckTourCommentsReactionCreate(requestParameters.uuid, requestParameters.c24session, requestParameters.truckTourCommentsReactionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * delete comment reaction
         * @param {TruckTourApiTruckTourCommentsReactionDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsReactionDelete(requestParameters: TruckTourApiTruckTourCommentsReactionDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TruckTourCommentsReactionCreate201ResponseInner>> {
            return localVarFp.truckTourCommentsReactionDelete(requestParameters.uuid, requestParameters.reactionTypeName, options).then((request) => request(axios, basePath));
        },
        /**
         * Report a truck tour comment
         * @param {TruckTourApiTruckTourCommentsReportCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsReportCreate(requestParameters: TruckTourApiTruckTourCommentsReportCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokCommentWithSuspendedDeleted> {
            return localVarFp.truckTourCommentsReportCreate(requestParameters.uuid, requestParameters.truckTourCommentsReportCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TruckTourApiTruckTourCommentsShowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsShow(requestParameters: TruckTourApiTruckTourCommentsShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokCommentWithSuspendedDeleted> {
            return localVarFp.truckTourCommentsShow(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a truck tour comment
         * @param {TruckTourApiTruckTourCommentsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourCommentsUpdate(requestParameters: TruckTourApiTruckTourCommentsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChecktokCommentWithSuspendedDeleted> {
            return localVarFp.truckTourCommentsUpdate(requestParameters.uuid, requestParameters.truckTourCommentsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourGlobalConfigsIndex(options?: RawAxiosRequestConfig): AxiosPromise<TruckTourGlobalConfigsIndex200Response> {
            return localVarFp.truckTourGlobalConfigsIndex(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourLiveIndex(options?: RawAxiosRequestConfig): AxiosPromise<TruckTourLiveIndex200Response> {
            return localVarFp.truckTourLiveIndex(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourLotteryEventsIndex(options?: RawAxiosRequestConfig): AxiosPromise<TruckTourLotteryEventsIndex200Response> {
            return localVarFp.truckTourLotteryEventsIndex(options).then((request) => request(axios, basePath));
        },
        /**
         * Create media for truck tour
         * @param {TruckTourApiTruckTourMediaCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourMediaCreate(requestParameters: TruckTourApiTruckTourMediaCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourMediaCreate200Response> {
            return localVarFp.truckTourMediaCreate(requestParameters.media, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostSuggestedStopsIndex(options?: RawAxiosRequestConfig): AxiosPromise<TruckTourPostSuggestedStopsIndex200Response> {
            return localVarFp.truckTourPostSuggestedStopsIndex(options).then((request) => request(axios, basePath));
        },
        /**
         * list post comments
         * @param {TruckTourApiTruckTourPostsCommentsIndexRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsCommentsIndex(requestParameters: TruckTourApiTruckTourPostsCommentsIndexRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChecktokCommentWithSuspendedDeleted>> {
            return localVarFp.truckTourPostsCommentsIndex(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a post for a truck tour stop
         * @param {TruckTourApiTruckTourPostsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsCreate(requestParameters: TruckTourApiTruckTourPostsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostCreateResponse> {
            return localVarFp.truckTourPostsCreate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single post for Truck Tour
         * @param {TruckTourApiTruckTourPostsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsDelete(requestParameters: TruckTourApiTruckTourPostsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourPostsDelete200Response> {
            return localVarFp.truckTourPostsDelete(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TruckTourApiTruckTourPostsDetailsShowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsDetailsShow(requestParameters: TruckTourApiTruckTourPostsDetailsShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourPostsDetailsShow200Response> {
            return localVarFp.truckTourPostsDetailsShow(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TruckTourApiTruckTourPostsIndexRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsIndex(requestParameters: TruckTourApiTruckTourPostsIndexRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourPostsIndex200Response> {
            return localVarFp.truckTourPostsIndex(requestParameters.limit, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * create post reaction
         * @param {TruckTourApiTruckTourPostsReactionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsReactionCreate(requestParameters: TruckTourApiTruckTourPostsReactionCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourPostReactionOutput> {
            return localVarFp.truckTourPostsReactionCreate(requestParameters.uuid, requestParameters.c24session, requestParameters.truckTourCommentsReactionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * delete post reaction
         * @param {TruckTourApiTruckTourPostsReactionDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsReactionDelete(requestParameters: TruckTourApiTruckTourPostsReactionDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TruckTourPostsReactionDelete200ResponseInner>> {
            return localVarFp.truckTourPostsReactionDelete(requestParameters.uuid, requestParameters.reactionTypeName, options).then((request) => request(axios, basePath));
        },
        /**
         * Report on a single post for breaching the truck tour guidelines
         * @param {TruckTourApiTruckTourPostsReportCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsReportCreate(requestParameters: TruckTourApiTruckTourPostsReportCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.truckTourPostsReportCreate(requestParameters.uuid, requestParameters.truckTourCommentsReportCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TruckTourApiTruckTourPostsShowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsShow(requestParameters: TruckTourApiTruckTourPostsShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourPostsShow200Response> {
            return localVarFp.truckTourPostsShow(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a truck tour post
         * @param {TruckTourApiTruckTourPostsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourPostsUpdate(requestParameters: TruckTourApiTruckTourPostsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostUpdateResponse> {
            return localVarFp.truckTourPostsUpdate(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve report classifications by provided report classification type
         * @param {TruckTourApiTruckTourReportsClassificationIndexRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourReportsClassificationIndex(requestParameters: TruckTourApiTruckTourReportsClassificationIndexRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TruckTourReportsClassificationIndex200ResponseInner>> {
            return localVarFp.truckTourReportsClassificationIndex(requestParameters.reportClassType, requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TruckTourApiTruckTourRouteShowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourRouteShow(requestParameters: TruckTourApiTruckTourRouteShowRequest, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourRouteShow200Response> {
            return localVarFp.truckTourRouteShow(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourSearchApplicationsIndex(options?: RawAxiosRequestConfig): AxiosPromise<TruckTourSearchApplicationsIndex200Response> {
            return localVarFp.truckTourSearchApplicationsIndex(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TruckTourApiTruckTourStreamCommentsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourStreamCommentsCreate(requestParameters: TruckTourApiTruckTourStreamCommentsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourStreamCommentsCreate200Response> {
            return localVarFp.truckTourStreamCommentsCreate(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TruckTourApiTruckTourStreamCommentsIndexRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourStreamCommentsIndex(requestParameters: TruckTourApiTruckTourStreamCommentsIndexRequest, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourStreamCommentsIndex200Response> {
            return localVarFp.truckTourStreamCommentsIndex(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get truck tour user configuration settings
         * @param {TruckTourApiTruckTourUserConfigIndexRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourUserConfigIndex(requestParameters: TruckTourApiTruckTourUserConfigIndexRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourUserConfigIndex200Response> {
            return localVarFp.truckTourUserConfigIndex(requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
        /**
         * Get truck tour user profile
         * @param {TruckTourApiTruckTourUserProfileIndexRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourUserProfileIndex(requestParameters: TruckTourApiTruckTourUserProfileIndexRequest, options?: RawAxiosRequestConfig): AxiosPromise<TruckTourUserProfileIndex200Response> {
            return localVarFp.truckTourUserProfileIndex(requestParameters.c24session, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        truckTourWidgetsIndex(options?: RawAxiosRequestConfig): AxiosPromise<WidgetOutput> {
            return localVarFp.truckTourWidgetsIndex(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tuckTourRoutesIndex(options?: RawAxiosRequestConfig): AxiosPromise<TuckTourRoutesIndex200Response> {
            return localVarFp.tuckTourRoutesIndex(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for truckTourAuthValidateIndex operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourAuthValidateIndexRequest
 */
export interface TruckTourApiTruckTourAuthValidateIndexRequest {
    /**
     * 
     * @type {string}
     * @memberof TruckTourApiTruckTourAuthValidateIndex
     */
    readonly c24session?: string
}

/**
 * Request parameters for truckTourCommentsCreate operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourCommentsCreateRequest
 */
export interface TruckTourApiTruckTourCommentsCreateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourCommentsCreate
     */
    readonly uuid: string

    /**
     * 
     * @type {TruckTourCommentsCreateRequest}
     * @memberof TruckTourApiTruckTourCommentsCreate
     */
    readonly truckTourCommentsCreateRequest?: TruckTourCommentsCreateRequest
}

/**
 * Request parameters for truckTourCommentsDelete operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourCommentsDeleteRequest
 */
export interface TruckTourApiTruckTourCommentsDeleteRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourCommentsDelete
     */
    readonly uuid: string
}

/**
 * Request parameters for truckTourCommentsReactionCreate operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourCommentsReactionCreateRequest
 */
export interface TruckTourApiTruckTourCommentsReactionCreateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourCommentsReactionCreate
     */
    readonly uuid: string

    /**
     * 
     * @type {string}
     * @memberof TruckTourApiTruckTourCommentsReactionCreate
     */
    readonly c24session: string

    /**
     * 
     * @type {TruckTourCommentsReactionCreateRequest}
     * @memberof TruckTourApiTruckTourCommentsReactionCreate
     */
    readonly truckTourCommentsReactionCreateRequest?: TruckTourCommentsReactionCreateRequest
}

/**
 * Request parameters for truckTourCommentsReactionDelete operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourCommentsReactionDeleteRequest
 */
export interface TruckTourApiTruckTourCommentsReactionDeleteRequest {
    /**
     * id of the comment to remove its reaction
     * @type {string}
     * @memberof TruckTourApiTruckTourCommentsReactionDelete
     */
    readonly uuid: string

    /**
     * reaction type name to react with
     * @type {string}
     * @memberof TruckTourApiTruckTourCommentsReactionDelete
     */
    readonly reactionTypeName: string
}

/**
 * Request parameters for truckTourCommentsReportCreate operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourCommentsReportCreateRequest
 */
export interface TruckTourApiTruckTourCommentsReportCreateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourCommentsReportCreate
     */
    readonly uuid: string

    /**
     * 
     * @type {TruckTourCommentsReportCreateRequest}
     * @memberof TruckTourApiTruckTourCommentsReportCreate
     */
    readonly truckTourCommentsReportCreateRequest?: TruckTourCommentsReportCreateRequest
}

/**
 * Request parameters for truckTourCommentsShow operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourCommentsShowRequest
 */
export interface TruckTourApiTruckTourCommentsShowRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourCommentsShow
     */
    readonly uuid: string
}

/**
 * Request parameters for truckTourCommentsUpdate operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourCommentsUpdateRequest
 */
export interface TruckTourApiTruckTourCommentsUpdateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourCommentsUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {TruckTourCommentsUpdateRequest}
     * @memberof TruckTourApiTruckTourCommentsUpdate
     */
    readonly truckTourCommentsUpdateRequest?: TruckTourCommentsUpdateRequest
}

/**
 * Request parameters for truckTourMediaCreate operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourMediaCreateRequest
 */
export interface TruckTourApiTruckTourMediaCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TruckTourApiTruckTourMediaCreate
     */
    readonly media: string
}

/**
 * Request parameters for truckTourPostsCommentsIndex operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourPostsCommentsIndexRequest
 */
export interface TruckTourApiTruckTourPostsCommentsIndexRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsCommentsIndex
     */
    readonly uuid: string
}

/**
 * Request parameters for truckTourPostsCreate operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourPostsCreateRequest
 */
export interface TruckTourApiTruckTourPostsCreateRequest {
    /**
     * id of the post stop
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsCreate
     */
    readonly id: string
}

/**
 * Request parameters for truckTourPostsDelete operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourPostsDeleteRequest
 */
export interface TruckTourApiTruckTourPostsDeleteRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsDelete
     */
    readonly uuid: string
}

/**
 * Request parameters for truckTourPostsDetailsShow operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourPostsDetailsShowRequest
 */
export interface TruckTourApiTruckTourPostsDetailsShowRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsDetailsShow
     */
    readonly uuid: string
}

/**
 * Request parameters for truckTourPostsIndex operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourPostsIndexRequest
 */
export interface TruckTourApiTruckTourPostsIndexRequest {
    /**
     * number of posts in page
     * @type {number}
     * @memberof TruckTourApiTruckTourPostsIndex
     */
    readonly limit?: number

    /**
     * 
     * @type {CursorParam}
     * @memberof TruckTourApiTruckTourPostsIndex
     */
    readonly cursor?: CursorParam
}

/**
 * Request parameters for truckTourPostsReactionCreate operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourPostsReactionCreateRequest
 */
export interface TruckTourApiTruckTourPostsReactionCreateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsReactionCreate
     */
    readonly uuid: string

    /**
     * 
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsReactionCreate
     */
    readonly c24session: string

    /**
     * 
     * @type {TruckTourCommentsReactionCreateRequest}
     * @memberof TruckTourApiTruckTourPostsReactionCreate
     */
    readonly truckTourCommentsReactionCreateRequest?: TruckTourCommentsReactionCreateRequest
}

/**
 * Request parameters for truckTourPostsReactionDelete operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourPostsReactionDeleteRequest
 */
export interface TruckTourApiTruckTourPostsReactionDeleteRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsReactionDelete
     */
    readonly uuid: string

    /**
     * reaction type name to react with
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsReactionDelete
     */
    readonly reactionTypeName: string
}

/**
 * Request parameters for truckTourPostsReportCreate operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourPostsReportCreateRequest
 */
export interface TruckTourApiTruckTourPostsReportCreateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsReportCreate
     */
    readonly uuid: string

    /**
     * 
     * @type {TruckTourCommentsReportCreateRequest}
     * @memberof TruckTourApiTruckTourPostsReportCreate
     */
    readonly truckTourCommentsReportCreateRequest?: TruckTourCommentsReportCreateRequest
}

/**
 * Request parameters for truckTourPostsShow operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourPostsShowRequest
 */
export interface TruckTourApiTruckTourPostsShowRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsShow
     */
    readonly uuid: string
}

/**
 * Request parameters for truckTourPostsUpdate operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourPostsUpdateRequest
 */
export interface TruckTourApiTruckTourPostsUpdateRequest {
    /**
     * uuid of the truck tour post to be edited
     * @type {string}
     * @memberof TruckTourApiTruckTourPostsUpdate
     */
    readonly uuid: string
}

/**
 * Request parameters for truckTourReportsClassificationIndex operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourReportsClassificationIndexRequest
 */
export interface TruckTourApiTruckTourReportsClassificationIndexRequest {
    /**
     * report classification type
     * @type {'GENERAL' | 'CONTENT' | 'USER'}
     * @memberof TruckTourApiTruckTourReportsClassificationIndex
     */
    readonly reportClassType: TruckTourReportsClassificationIndexReportClassTypeEnum

    /**
     * 
     * @type {string}
     * @memberof TruckTourApiTruckTourReportsClassificationIndex
     */
    readonly c24session?: string
}

/**
 * Request parameters for truckTourRouteShow operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourRouteShowRequest
 */
export interface TruckTourApiTruckTourRouteShowRequest {
    /**
     * id of the entry
     * @type {string}
     * @memberof TruckTourApiTruckTourRouteShow
     */
    readonly id: string
}

/**
 * Request parameters for truckTourStreamCommentsCreate operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourStreamCommentsCreateRequest
 */
export interface TruckTourApiTruckTourStreamCommentsCreateRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourStreamCommentsCreate
     */
    readonly uuid: string
}

/**
 * Request parameters for truckTourStreamCommentsIndex operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourStreamCommentsIndexRequest
 */
export interface TruckTourApiTruckTourStreamCommentsIndexRequest {
    /**
     * uuid of the content
     * @type {string}
     * @memberof TruckTourApiTruckTourStreamCommentsIndex
     */
    readonly uuid: string
}

/**
 * Request parameters for truckTourUserConfigIndex operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourUserConfigIndexRequest
 */
export interface TruckTourApiTruckTourUserConfigIndexRequest {
    /**
     * 
     * @type {string}
     * @memberof TruckTourApiTruckTourUserConfigIndex
     */
    readonly c24session?: string
}

/**
 * Request parameters for truckTourUserProfileIndex operation in TruckTourApi.
 * @export
 * @interface TruckTourApiTruckTourUserProfileIndexRequest
 */
export interface TruckTourApiTruckTourUserProfileIndexRequest {
    /**
     * 
     * @type {string}
     * @memberof TruckTourApiTruckTourUserProfileIndex
     */
    readonly c24session: string
}

/**
 * TruckTourApi - object-oriented interface
 * @export
 * @class TruckTourApi
 * @extends {BaseAPI}
 */
export class TruckTourApi extends BaseAPI {
    /**
     * Validate authentication of the c24 session for Truck
     * @param {TruckTourApiTruckTourAuthValidateIndexRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourAuthValidateIndex(requestParameters: TruckTourApiTruckTourAuthValidateIndexRequest = {}, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourAuthValidateIndex(requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new truck tour comment
     * @param {TruckTourApiTruckTourCommentsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourCommentsCreate(requestParameters: TruckTourApiTruckTourCommentsCreateRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourCommentsCreate(requestParameters.uuid, requestParameters.truckTourCommentsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a truck tour comment
     * @param {TruckTourApiTruckTourCommentsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourCommentsDelete(requestParameters: TruckTourApiTruckTourCommentsDeleteRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourCommentsDelete(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create comment reaction
     * @param {TruckTourApiTruckTourCommentsReactionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourCommentsReactionCreate(requestParameters: TruckTourApiTruckTourCommentsReactionCreateRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourCommentsReactionCreate(requestParameters.uuid, requestParameters.c24session, requestParameters.truckTourCommentsReactionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete comment reaction
     * @param {TruckTourApiTruckTourCommentsReactionDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourCommentsReactionDelete(requestParameters: TruckTourApiTruckTourCommentsReactionDeleteRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourCommentsReactionDelete(requestParameters.uuid, requestParameters.reactionTypeName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report a truck tour comment
     * @param {TruckTourApiTruckTourCommentsReportCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourCommentsReportCreate(requestParameters: TruckTourApiTruckTourCommentsReportCreateRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourCommentsReportCreate(requestParameters.uuid, requestParameters.truckTourCommentsReportCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TruckTourApiTruckTourCommentsShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourCommentsShow(requestParameters: TruckTourApiTruckTourCommentsShowRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourCommentsShow(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a truck tour comment
     * @param {TruckTourApiTruckTourCommentsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourCommentsUpdate(requestParameters: TruckTourApiTruckTourCommentsUpdateRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourCommentsUpdate(requestParameters.uuid, requestParameters.truckTourCommentsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourGlobalConfigsIndex(options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourGlobalConfigsIndex(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourLiveIndex(options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourLiveIndex(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourLotteryEventsIndex(options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourLotteryEventsIndex(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create media for truck tour
     * @param {TruckTourApiTruckTourMediaCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourMediaCreate(requestParameters: TruckTourApiTruckTourMediaCreateRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourMediaCreate(requestParameters.media, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostSuggestedStopsIndex(options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostSuggestedStopsIndex(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * list post comments
     * @param {TruckTourApiTruckTourPostsCommentsIndexRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostsCommentsIndex(requestParameters: TruckTourApiTruckTourPostsCommentsIndexRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostsCommentsIndex(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a post for a truck tour stop
     * @param {TruckTourApiTruckTourPostsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostsCreate(requestParameters: TruckTourApiTruckTourPostsCreateRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostsCreate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single post for Truck Tour
     * @param {TruckTourApiTruckTourPostsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostsDelete(requestParameters: TruckTourApiTruckTourPostsDeleteRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostsDelete(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TruckTourApiTruckTourPostsDetailsShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostsDetailsShow(requestParameters: TruckTourApiTruckTourPostsDetailsShowRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostsDetailsShow(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TruckTourApiTruckTourPostsIndexRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostsIndex(requestParameters: TruckTourApiTruckTourPostsIndexRequest = {}, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostsIndex(requestParameters.limit, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create post reaction
     * @param {TruckTourApiTruckTourPostsReactionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostsReactionCreate(requestParameters: TruckTourApiTruckTourPostsReactionCreateRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostsReactionCreate(requestParameters.uuid, requestParameters.c24session, requestParameters.truckTourCommentsReactionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * delete post reaction
     * @param {TruckTourApiTruckTourPostsReactionDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostsReactionDelete(requestParameters: TruckTourApiTruckTourPostsReactionDeleteRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostsReactionDelete(requestParameters.uuid, requestParameters.reactionTypeName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report on a single post for breaching the truck tour guidelines
     * @param {TruckTourApiTruckTourPostsReportCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostsReportCreate(requestParameters: TruckTourApiTruckTourPostsReportCreateRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostsReportCreate(requestParameters.uuid, requestParameters.truckTourCommentsReportCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TruckTourApiTruckTourPostsShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostsShow(requestParameters: TruckTourApiTruckTourPostsShowRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostsShow(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a truck tour post
     * @param {TruckTourApiTruckTourPostsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourPostsUpdate(requestParameters: TruckTourApiTruckTourPostsUpdateRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourPostsUpdate(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve report classifications by provided report classification type
     * @param {TruckTourApiTruckTourReportsClassificationIndexRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourReportsClassificationIndex(requestParameters: TruckTourApiTruckTourReportsClassificationIndexRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourReportsClassificationIndex(requestParameters.reportClassType, requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TruckTourApiTruckTourRouteShowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourRouteShow(requestParameters: TruckTourApiTruckTourRouteShowRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourRouteShow(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourSearchApplicationsIndex(options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourSearchApplicationsIndex(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TruckTourApiTruckTourStreamCommentsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourStreamCommentsCreate(requestParameters: TruckTourApiTruckTourStreamCommentsCreateRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourStreamCommentsCreate(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TruckTourApiTruckTourStreamCommentsIndexRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourStreamCommentsIndex(requestParameters: TruckTourApiTruckTourStreamCommentsIndexRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourStreamCommentsIndex(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get truck tour user configuration settings
     * @param {TruckTourApiTruckTourUserConfigIndexRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourUserConfigIndex(requestParameters: TruckTourApiTruckTourUserConfigIndexRequest = {}, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourUserConfigIndex(requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get truck tour user profile
     * @param {TruckTourApiTruckTourUserProfileIndexRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourUserProfileIndex(requestParameters: TruckTourApiTruckTourUserProfileIndexRequest, options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourUserProfileIndex(requestParameters.c24session, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public truckTourWidgetsIndex(options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).truckTourWidgetsIndex(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TruckTourApi
     */
    public tuckTourRoutesIndex(options?: RawAxiosRequestConfig) {
        return TruckTourApiFp(this.configuration).tuckTourRoutesIndex(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const TruckTourReportsClassificationIndexReportClassTypeEnum = {
    General: 'GENERAL',
    Content: 'CONTENT',
    User: 'USER'
} as const;
export type TruckTourReportsClassificationIndexReportClassTypeEnum = typeof TruckTourReportsClassificationIndexReportClassTypeEnum[keyof typeof TruckTourReportsClassificationIndexReportClassTypeEnum];


